//enable the tooltips
$(function () {
    $pledgePayBody = $('#pledge_pay_body');
    if ($pledgePayBody.length) {
        pledgePayBootstrapOpenBalanceAvailable($pledgePayBody);
    }
    $pledgePayBody.find('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });
});

function getCsrfToken() {
    if (window.csrf_token) {
        return window.csrf_token;
    }
    const metaToken = document.querySelector('meta[name="csrf-token"]');
    return metaToken ? metaToken.getAttribute('content') : '';
}

function escHtml(value) {
    return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
}

function buildGatewayCampaignGroups(pledges) {
    const groups = new Map();

    for (const {gateway_id: gatewayId, campaign} of pledges || []) {
        if (!gatewayId) continue;

        if (!groups.has(gatewayId)) {
            groups.set(gatewayId, new Set());
        }

        groups.get(gatewayId).add(campaign || 'Unknown campaign');
    }

    return [...groups].map(([gatewayId, campaigns]) => ({
        gatewayId,
        campaigns: [...campaigns],
    })).sort((a, b) =>
        String(a.gatewayId).localeCompare(String(b.gatewayId), undefined, {numeric: true})
    );
}

function updateMultiGatewayPaymentModeWarning($container, pledges, payType = 'pay') {
    if (!$container || !$container.length) {
        return;
    }

    const gatewayIds = (pledges || [])
        .map(pledge => pledge.gateway_id)
        .filter(gateway_id => gateway_id !== null && gateway_id !== undefined && gateway_id !== '');
    const hasMultipleGateways = new Set(gatewayIds).size > 1;

    const $recurringPayment = $container.find('#recurring_payment');
    const $fullPayment = $container.find('#full_payment');
    const $multiGatewayWarning = $container.find('#multi_gateway_payment_mode_warning');
    const $multiGatewayWarningDetails = $container.find('#multi_gateway_payment_mode_warning_details');
    const $recurringPaymentLabel = $container.find('label[for="recurring_payment"]');

    const shouldDisableRecurring = payType === 'pay'
        && (pledges || []).length > 1
        && hasMultipleGateways;

    if (shouldDisableRecurring) {
        if ($recurringPayment.length) {
            $recurringPayment.prop('checked', false).prop('disabled', true);
        }
        if ($recurringPaymentLabel.length) {
            $recurringPaymentLabel.addClass('is-disabled');
        }
        if ($fullPayment.length) {
            $fullPayment.prop('checked', true);
        }
        if ($multiGatewayWarning.length) {
            $multiGatewayWarning.show();
        }
        if ($multiGatewayWarningDetails.length) {
            $multiGatewayWarningDetails.empty();
            const groupedCampaigns = buildGatewayCampaignGroups(pledges);
            if (groupedCampaigns.length) {
                const $intro = $('<div>').text(
                    "If you'd like to set up recurring payments, you can select the pledges that belong to these campaigns separately:"
                );
                const $list = $('<ul class="mb-0 pl-3">');
                groupedCampaigns.forEach((group) => {
                    const campaignList = group.campaigns.length ? group.campaigns.join(', ') : 'No campaigns selected';
                    $list.append($('<li>').text(`${campaignList}`));
                });
                $multiGatewayWarningDetails.append($intro, $list);
            }
        }

        if ($container.attr('id') === 'pledge_pay_body' && $fullPayment.length) {
            handlePledgePaymentModeChange($fullPayment);
        }
        return;
    }

    if ($multiGatewayWarning.length) {
        $multiGatewayWarning.hide();
    }
    if ($multiGatewayWarningDetails.length) {
        $multiGatewayWarningDetails.empty();
    }
    if ($recurringPayment.length) {
        $recurringPayment.prop('disabled', false);
    }
    if ($recurringPaymentLabel.length) {
        $recurringPaymentLabel.removeClass('is-disabled');
    }
}


function mgrPledgeBillShellDismissIfModal($shell) {
    if ($shell && $shell.length && $shell.is('#setPledgePaymentModal')) {
        $shell.modal('hide');
        $('.modal-backdrop').remove();
    }
}

function handlePledgePaymentModeChange($input) {
    const $parentDiv = $('#pledge_pay_body');
    if (!$parentDiv.length) {
        return;
    }

    const isRecurring = $input.val() === 'recurring';
    const $recurringSetup = $parentDiv.find('.recurring-setup');
    const $payNowButton = $parentDiv.find('#pay_now_button');

    function placeRecurringFieldsInSummary(showInSummary) {
        const $home = $parentDiv.find('#mgr_recurring_fields_home');
        const $slot = $parentDiv.find('#mgr_recurring_fields_slot');
        if (!$home.length || !$slot.length) {
            return;
        }
        if (showInSummary) {
            if (!$slot.children().length) {
                $slot.append($home.children());
            }
            $slot.show();
        } else {
            if ($slot.children().length) {
                $home.append($slot.children());
            }
            $slot.hide();
        }
    }

    if (isRecurring) {
        if (($parentDiv.closest('#setPledgePaymentModal').length)
            && typeof mgrPledgeModalSyncOpenPaymentVisibility === 'function') {
            mgrPledgeModalSyncOpenPaymentVisibility($parentDiv);
        }
        $recurringSetup.show()
            .find('input:not([type="checkbox"]), select, textarea')
            .prop('required', true);
        placeRecurringFieldsInSummary(true);
        if ($payNowButton.length) {
            setPledgePayNowButtonLabel($payNowButton, 'Setup Recurring Payment');
            $payNowButton.attr('title', 'Setup recurring payment schedule');
        }

        setTimeout(function() {
            window.initPledgeScheduleStartDatepicker($parentDiv);
        }, 100);

        setTimeout(function() {
            if (typeof calculateRecurringPaymentAmount === 'function') {
                calculateRecurringPaymentAmount();
            }
        }, 100);
    } else {
        $parentDiv.find('#recurring-payment-display').hide();
        $recurringSetup.hide()
            .find('input, select, textarea')
            .prop('required', false);
        placeRecurringFieldsInSummary(false);
        if ($payNowButton.length) {
            if (($parentDiv.closest('#setPledgePaymentModal').length)
                && typeof mgrPledgeModalSyncOpenPaymentVisibility === 'function') {
                mgrPledgeModalSyncOpenPaymentVisibility($parentDiv);
            } else {
                setPledgePayNowButtonLabel($payNowButton, 'Make Payment');
                $payNowButton.attr('title', 'You must save Matanah amounts prior to paying');
            }
        }

        if (typeof destroyRecurringTable === 'function') {
            destroyRecurringTable($parentDiv);
        }
    }

    if (isRecurring && typeof setPledgeStartDateByFrequency === 'function') {
        const $frequencySelect = $parentDiv.find('select[name="frequency"]');
        if ($frequencySelect.length) {
            setPledgeStartDateByFrequency($parentDiv, $frequencySelect.val());
        }
    }

    if (typeof renderPledgePaymentTable === 'function' && window.payBillModalSelectedPledges) {
        const $modBodyInfo = $parentDiv.find('#set_pledge_payment_table');
        if ($modBodyInfo.length) {
            const result = renderPledgePaymentTable(
                window.payBillModalSelectedPledges,
                isRecurring,
                $parentDiv
            );

            $parentDiv.find('#total_amount').val(result.totalAmount);

            if (result.matanahFound) {
                $parentDiv.find("#cover_surcharge").prop('disabled', true);
            }
            updatePledgePayNowButtonEnabledState($parentDiv);
        }
    }

    // Important: initialize sortable AFTER table re-render (renderPledgePaymentTable replaces DOM).
    if (isRecurring) {
        if (typeof initializeRecurringTable === 'function') {
            initializeRecurringTable($parentDiv);
        }
    } else {
        if (typeof destroyRecurringTable === 'function') {
            destroyRecurringTable($parentDiv);
        }
    }

    pledgePaymentBodySyncOpenPaymentSummary($parentDiv, isRecurring);
}

/**
 * Within #pledge_pay_body: show open-payment + totals columns for one-time pay; hide both columns for recurring
 * (whole #mgr_pledge_summary_section is also toggled by mgrPledgeModalSyncSummaryVisibility).
 */
function pledgePayBillSyncSummaryColumnLayout($body, isRecurring) {
    if (!$body || !$body.length) {
        return;
    }
    const $leftCol = $body.find('.pledge-pay-summary-open-payment-col');
    const $rightCol = $body.find('#mgr_pledge_summary_right_col');
    const $totalsWrap = $body.find('#mgr_summary_totals_wrap');
    const $slot = $body.find('#mgr_recurring_fields_slot');
    const $home = $body.find('#mgr_recurring_fields_home');

    if (isRecurring) {
        if ($leftCol.length) {
            $leftCol.hide();
        }
        if ($totalsWrap.length) {
            $totalsWrap.hide();
        }
        // Move recurring fields into right-side slot (panel styled) for recurring mode.
        if ($home.length && $slot.length) {
            if (!$slot.children().length) {
                $slot.append($home.children());
            }
            $slot.show();
        }
        if ($body.find('#mgr_use_open_payment_balance').length) {
            $body.find('#mgr_use_open_payment_balance').prop('checked', false);
        }
        if ($body.find('#mgr_open_payment_apply_amount').length) {
            $body.find('#mgr_open_payment_apply_amount').val('');
        }
        mgrPledgeModalSyncOpenPaymentApplyControls($body);
        return;
    }

    if ($leftCol.length) {
        $leftCol.show();
    }
    if ($rightCol.length) {
        $rightCol.show().removeClass('col-12').addClass('col-md-6');
    }
    if ($totalsWrap.length) {
        $totalsWrap.show();
    }
    // Move recurring fields back "home" for non-recurring mode.
    if ($home.length && $slot.length) {
        if ($slot.children().length) {
            $home.append($slot.children());
        }
        $slot.hide();
    }

    const t = getOpenBalanceAvailable();
    if (t <= 0) {
        if ($body.find('#mgr_use_open_payment_balance').length) {
            $body.find('#mgr_use_open_payment_balance').prop('checked', false);
        }
        if ($body.find('#mgr_open_payment_apply_amount').length) {
            $body.find('#mgr_open_payment_apply_amount').val('');
        }
        mgrPledgeModalSyncOpenPaymentApplyControls($body);
    }

    mgrPledgeModalSyncGatewayCreditPanelDisplay($body);
    mgrPledgeModalSyncOpenPaymentStates($body);
    mgrPledgeModalRecalcOpenApplyCap($body);
}

$(document).ready(function () {
    $(document).on('change', 'input[name="payment_mode"]', function () {
        handlePledgePaymentModeChange($(this));
    });

    $(document).on('change', '#pledge_pay_body select[name="frequency"]', function () {
        setPledgeStartDateByFrequency($('#pledge_pay_body'), $(this).val());
    });

    $(document).on('change', '#pledge_pay_body #cover_surcharge', function () {
        calculateRecurringPaymentAmount();
    });

    $(document).on('input change', '#set_payment_table input[name="amount_paid"], .mgr-pledge-gateway-payment-table input[name="amount_paid"]', function () {
        if ($(this).prop('disabled')) {
            return;
        }
        runChangeAmount(this);
    });

    // Prevent Enter from submitting while editing amounts.
    $(document).on('keydown', '#set_payment_table input[name="amount_paid"], .mgr-pledge-gateway-payment-table input[name="amount_paid"], .matanah_amt_entry', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            return false;
        }
    });
});

function getPledgeStartDateFromFrequency(frequency) {
    if (!frequency) return null;

    var date = new Date();
    switch (frequency) {
        case "weekly":
            date.setDate(date.getDate() + 7);
            break;
        case "monthly":
            date.setMonth(date.getMonth() + 1);
            break;
        case "annually":
            date.setFullYear(date.getFullYear() + 1);
            break;
        default:
            return null;
    }

    return date.toLocaleDateString('es-pa');
}

function setPledgeStartDateByFrequency($container, frequency) {
    var newDate = getPledgeStartDateFromFrequency(frequency);
    if (!newDate) return;

    var $input = $container.find('input[name="pledge_start_date"]');
    if ($input.length) {
        $input.val(newDate);
    }

    var $datepicker = window.pledgeScheduleStartDatepickerWidget($container);
    if ($datepicker.length && $datepicker.datepicker) {
        $datepicker.datepicker("setDate", newDate);
    }
}

/** Sum of amount-to-pay inputs; same basis as #amt_due_total in runChangeAmount. */
function sumPledgeAmountPaidInputs($container) {
    const $wrap = $container.find('#set_pledge_payment_table');
    const $inputs = ($wrap.length && $wrap.find('.mgr-pledge-gateway-payment-table').length)
        ? $wrap.find('.mgr-pledge-gateway-payment-table input[name="amount_paid"]')
        : $container.find('input[name="amount_paid"]');
    const $filtered = $inputs.filter(function () {
        const $tr = $(this).closest('tr');
        if (!$tr.length) {
            return true;
        }
        const $cb = $tr.find('input.statement-pledge-select');
        return !$cb.length || $cb.prop('checked');
    });
    return $filtered.toArray().reduce(
        (sum, i) => sum + (parseFloat(String(i.value).replace(/,/g, '')) || 0),
        0
    );
}

/** Sum original amount due per pledge row (unchanged when user edits "amount to pay"). */
function sumPledgeBalanceDueOriginal($modal) {
    const $rows = $modal.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr').length
        ? $modal.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr')
        : $modal.find('#set_payment_table tbody tr');
    const $filtered = $rows.filter(function () {
        const $cb = $(this).find('input.statement-pledge-select');
        return !$cb.length || $cb.prop('checked');
    });
    return $filtered.toArray().reduce((sum, tr) => {
        const v = parseFloat($(tr).attr('data-balance-due'));
        return sum + (Number.isFinite(v) ? v : 0);
    }, 0);
}

function sumPledgeAmountPaidForGateway($root, gatewayId) {
    const gid = String(gatewayId);
    let sum = 0;
    $root.find(`tr[data-gateway-id="${gid}"]`).each(function () {
        if (shouldSkipAmountToPayRowForStatement($(this), $root)) {
            return;
        }
        const $inp = $(this).find('input[name="amount_paid"]');
        if ($inp.length && !$inp.prop('disabled')) {
            sum += parseFloat(String($inp.val()).replace(/,/g, '')) || 0;
        }
    });
    return sum;
}

/**
 * Canonical open balance (USD) for the pledge pay-bill UI (member page or manager #pledge_pay_body in modal).
 * Set from #member_open_payment_balance_total on member bootstrap, or from the manager balance AJAX handler.
 */
function getOpenBalanceAvailable() {
    const v = window.openBalanceAvailable;
    return typeof v === 'number' && Number.isFinite(v) ? Math.max(0, v) : 0;
}

/**
 * @param {number|string} amount
 * @param {JQuery} $pledgePayBody #pledge_pay_body root (updates #mgr_open_payment_available_amt when present)
 */
function setOpenBalanceAvailable(amount, $pledgePayBody) {
    const n = Math.round(Math.max(0, parseFloat(amount) || 0) * 100) / 100;
    window.openBalanceAvailable = n;
    if ($pledgePayBody && $pledgePayBody.length) {
        const $hid = $pledgePayBody.find('#member_open_payment_balance_total');
        if ($hid.length) {
            $hid.val(n.toFixed(2));
        }
        const $amt = $pledgePayBody.find('#mgr_open_payment_available_amt');
        if ($amt.length && typeof numberFormat === 'function') {
            $amt.text(numberFormat(n));
        } else if ($amt.length) {
            $amt.text(n.toFixed(2));
        }
    }
}

function pledgePayBootstrapOpenBalanceAvailable($pledgePayBody) {
    const $hidden = $pledgePayBody.find('#member_open_payment_balance_total');
    const raw = $hidden.length ? (parseFloat(String($hidden.val()).replace(/,/g, '')) || 0) : 0;
    setOpenBalanceAvailable(raw, $pledgePayBody);
}

/** #pledge_pay_body (member or modal): summary section visibility, column layout for payment mode, and totals. */
function pledgePaymentBodySyncOpenPaymentSummary($body, isRecurring) {
    if (!$body || !$body.length || !$body.is('#pledge_pay_body')) {
        return;
    }
    // Member pay-bill HTML is often injected after document ready; re-read #member_open_payment_balance_total
    // so getOpenBalanceAvailable() matches the server-rendered open balance. Manager #pledge_pay_body omits that
    // hidden input (balance is set by refreshManagerPledgeModalOpenPaymentSection); skip bootstrap there.
    if ($body.find('#member_open_payment_balance_total').length) {
        pledgePayBootstrapOpenBalanceAvailable($body);
    }
    if (!$body.find('#mgr_pledge_summary_section').length) {
        pledgePayBillSyncSummaryColumnLayout($body, !!isRecurring);
        return;
    }
    mgrPledgeModalSyncSummaryVisibility($body);
    pledgePayBillSyncSummaryColumnLayout($body, !!isRecurring);
    pledgePayBillUpdateSummary($body);
    if (typeof updatePledgePayNowButtonEnabledState === 'function') {
        updatePledgePayNowButtonEnabledState($body);
    }
}

/**
 * Shows #cover_surcharge_row when either required (campaign-mandated) or optional surcharge applies.
 * Do not use .is(':visible') on panels inside #cover_surcharge_row while the row is display:none —
 * jQuery treats descendants as not visible, so we use data flags set alongside the panel content.
 */
function pledgeUpdateSurchargeSectionRowVisibility($container) {
    const $surchargeSectionRow = $container.find('#cover_surcharge_row');
    if (!$surchargeSectionRow.length) {
        return;
    }
    const show =
        !!$surchargeSectionRow.data('mgrRequiredSurchargeActive') ||
        !!$surchargeSectionRow.data('mgrOptionalSurchargePanelActive');
    $surchargeSectionRow.toggle(show);
}

function mgrPledgeModalSyncPaymentTableFooter($modal) {
    const $foot = $modal.find('#set_payment_table tfoot, #set_pledge_payment_table .mgr-pledge-gateway-payment-table tfoot');
    if (!$foot.length) {
        return;
    }
    const fullMode = $modal.find('#full_payment').is(':checked');
    $foot.toggle(!fullMode);
}

function runChangeAmount(el) {
    const $container = $(el).closest('.modal, #pledge_pay_body, .modal-content');
    const $row = $(el).closest('tr');

    let val = parseFloat(el.value.replace(/,/g, '')) || 0;
    const min = parseFloat(el.min || 0);
    const max = parseFloat(el.max);

    const $msgBox = $container.find('.pledge-payment-message-div');
    const $msgUl = $container.find('.pledge-payment-message-ul');

    $msgBox.hide();
    $(el).css('border-color', '');

    if (el.value !== '' && val < min) {
        val = min;
        el.value = min;
        $(el).css('border-color', 'red');
        $msgUl.html(
            `<li><i class="fa-regular fa-circle-x"></i>&nbsp;
             The amount entered was less than the minimum. Please enter $${numberFormat(min)} or higher.</li>`
        );
        $msgBox.show();
    }

    if (el.value !== '' && val > max) {
        val = max;
        el.value = max;
        $(el).css('border-color', 'red');
        $msgUl.html(
            `<li><i class="fa-regular fa-circle-x"></i>&nbsp;
             Please enter an amount not more than the amount due.</li>`
        );
        $msgBox.show();
    }

    $row.attr('data-amount-to-pay', val);

    const total = sumPledgeAmountPaidInputs($container);

    $container.find('#amt_due_total, #amt_due_total_payment').html(`$${numberFormat(total)}`);

    const $mgrModal = $('#setPledgePaymentModal');
    if ($container.closest('#setPledgePaymentModal').length && $mgrModal.length) {
        mgrPledgeModalRecalcOpenApplyCap($mgrModal);
    }
    const $pledgeBody = $container.closest('#pledge_pay_body');
    if ($pledgeBody.length && $pledgeBody.find('#mgr_open_payment_apply_amount').length) {
        mgrPledgeModalRecalcOpenApplyCap($pledgeBody);
    }

    syncPledgeAmountToPayValidation($container);

    if (typeof pledgePayBillUpdateSummary === 'function') {
        pledgePayBillUpdateSummary(pledgePayUiRoot($container));
    }
}

function mgrPledgeModalSyncSummaryVisibility($modal) {
    const payType = $modal.find('#payment_type').val();
    const show = payType === 'pay';
    $modal.find('#mgr_pledge_summary_section').toggle(show);
    if (!show) {
        $modal.find('#mgr_pledge_fully_covered_row').hide();
    }
}

function mgrPledgeModalSyncOpenPaymentApplyControls($modal) {
    const $wrap = $modal.find('#mgr_open_payment_amount_wrap');
    const $inp = $modal.find('#mgr_open_payment_apply_amount');
    const $cb = $modal.find('#mgr_use_open_payment_balance');
    if (!$inp.length || !$cb.length) {
        return;
    }
    const checked = $cb.prop('checked');
    $inp.prop('disabled', !checked);
    $wrap.toggleClass('mgr-open-payment-apply-muted', !checked);
}

function mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, emptyShown) {
    $modal
        .find('#mgr_open_payment_empty_state')
        .parent()
        .toggleClass('mgr-pledge-panel--open-payment-empty', !!emptyShown);
}

function mgrPledgeModalSyncOpenPaymentStates($modal) {
    const payType = $modal.find('#payment_type').val();
    const mode = $modal.find('input[name="payment_mode"]:checked').val();
    if (payType !== 'pay' || mode === 'recurring') {
        mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, false);
        // Recurring: never show any open-credit UI (per-gateway or single pool).
        $modal.find('.mgr-gateway-credit-panel, .mgr-gateway-no-credit-note').hide();
        $modal.find('.mgr-gateway-use-credit').prop('checked', false).prop('disabled', true);
        $modal.find('.mgr-gateway-credit-apply').val('').prop('disabled', true);
        return;
    }
    if ($modal.find('.mgr-pledge-gateway-stack').length) {
        mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, false);
        $modal.find('.mgr-gateway-credit-panel').show();
        $modal.find('.mgr-gateway-use-credit').each(function () {
            const gid = String($(this).data('gateway-id') || '');
            const pool = parseFloat((window.openBalanceByGateway || {})[gid] ?? (window.openBalanceByGateway || {})[Number(gid)] ?? 0) || 0;
            $(this).prop('disabled', pool <= 0.005);
        });
        return;
    }
    const t = getOpenBalanceAvailable();
    if (t <= 0) {
        $modal.find('#mgr_open_payment_empty_state').show();
        $modal.find('#mgr_open_payment_active_state').hide();
        $modal.find('#mgr_open_payment_zero_display').text(numberFormat(0));
        mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, true);
    } else {
        $modal.find('#mgr_open_payment_empty_state').hide();
        $modal.find('#mgr_open_payment_active_state').show();
        $modal.find('#mgr_open_payment_available_amt').text(numberFormat(t));
        mgrPledgeModalSyncOpenPaymentApplyControls($modal);
        mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, false);
    }
}
function pledgePayBillUpdateSummaryUI($modal, tableTotal, balanceApplied) {
    const roundToCents = (amount) => Math.round(amount * 100) / 100;

    const totalPayingToday = roundToCents(tableTotal);
    const totalBalanceApplied = roundToCents(balanceApplied);

    const amountPaidOnline = roundToCents(
        Math.max(0, totalPayingToday - totalBalanceApplied)
    );

    const totalBalanceDue = roundToCents(
        sumPledgeBalanceDueOriginal($modal)
    );

    const remainingBalanceAfterPayment = roundToCents(
        Math.max(0, totalBalanceDue - totalPayingToday)
    );

    // update UI
    $modal.find('#mgr_summary_total_balance_due')
        .text('$' + numberFormat(totalBalanceDue));

    $modal.find('#mgr_summary_paying_today')
        .html(`<i class="fa-regular fa-credit-card mr-2" aria-hidden="true"></i>$${numberFormat(amountPaidOnline)}`);

    const $openPaymentLine = $modal.find('#mgr_summary_balance_applied');
    if (totalBalanceApplied > 0.005) {
        $openPaymentLine
            .text('- $' + numberFormat(totalBalanceApplied))
            .addClass('mgr-summary-open-payment-deduction');
    } else {
        $openPaymentLine
            .text('$' + numberFormat(0))
            .removeClass('mgr-summary-open-payment-deduction');
    }

    $modal.find('#mgr_summary_remaining_balance')
        .text('$' + numberFormat(remainingBalanceAfterPayment));

    $modal.find('#mgr_pledge_summary_section').attr({
        'data-online-due': String(amountPaidOnline),
        'data-paying-today-total': String(totalPayingToday),
    });

    const $methodRadios = $modal.find('.mgr-pledge-payment-method-radio');
    if ($methodRadios.length) {
        const disableCards = amountPaidOnline < 0.005;
        $methodRadios.prop('disabled', disableCards);
        $modal.find('.mgr-pledge-pay-method-cards')
            .toggleClass('mgr-pay-methods-disabled', disableCards)
            .css('pointer-events', disableCards ? 'none' : '');
        $modal.find('.mgr-pledge-pay-method-card').toggleClass('opacity-50', disableCards);
        if (disableCards) {
            $methodRadios.prop('checked', false);
            $modal.find('#mgr_pledge_bill_card_fields_wrap').hide();
        } else {
            $modal.find('#mgr_pledge_bill_card_fields_wrap').show();
            if (typeof window.mgrPledgeBillInitExpiryInputMask === 'function') {
                window.mgrPledgeBillInitExpiryInputMask($modal);
            }
            if (!$modal.find('input[name="mgr_pledge_payment_method_pref"]:checked').length) {
                const $savedPref = $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]');
                if ($savedPref.length && !$savedPref.prop('disabled')) {
                    $savedPref.prop('checked', true);
                } else {
                    $modal.find('input[name="mgr_pledge_payment_method_pref"][value="new"]').prop('checked', true);
                }
            }
            mgrPledgeModalSyncPaymentMethodPanels($modal);
        }
    }

    // nothing being paid
    if (totalPayingToday <= 0.005) {
        $modal.find('#mgr_pledge_fully_covered_row').hide();
        mgrPledgeModalSyncPrimaryButton($modal, amountPaidOnline, totalPayingToday);
        return;
    }

    const isGrouped = $modal.find('.mgr-pledge-gateway-stack').length > 0;
    const isUsingOpenBalance = isGrouped
        ? balanceApplied > 0.005
        : $modal.find('#mgr_use_open_payment_balance').prop('checked');

    const isFullyCoveredByBalance = isGrouped
        ? (balanceApplied > 0.005 && amountPaidOnline < 0.005 && totalPayingToday > 0.005)
        : (
            isUsingOpenBalance &&
            getOpenBalanceAvailable() > 0 &&
            amountPaidOnline < 0.005
        );

    $modal.find('#mgr_pledge_fully_covered_row')
        .toggle(isFullyCoveredByBalance);

    mgrPledgeModalSyncPrimaryButton($modal, amountPaidOnline, totalPayingToday);
}

function mgrPledgeModalMatchesSaveInsteadOfPayButton(online, tableTotal) {
    const o = typeof online === 'number' ? online : parseFloat(String(online ?? '').trim());
    const t = typeof tableTotal === 'number' ? tableTotal : parseFloat(String(tableTotal ?? '').trim());
    if (!Number.isFinite(o) || !Number.isFinite(t)) {
        return false;
    }
    return o < 0.005 && t > 0.005;
}

function setPledgePayNowButtonLabel($btn, label) {
    if (!$btn.length) {
        return;
    }
    if ($btn.prop('tagName') === 'BUTTON') {
        if (label === 'Save') {
            $btn.html('<i class="fa-regular fa-floppy-disk mr-1" aria-hidden="true"></i> Save');
        } else {
            $btn.text(label);
        }
    } else {
        $btn.val(label);
    }
}

function mgrPledgeModalSyncPrimaryButton($modal, online, tableTotal) {
    const payType = $modal.find('#payment_type').val();
    const mode = $modal.find('input[name="payment_mode"]:checked').val();
    const $btn = $modal.find('#pay_now_button');
    if (payType !== 'pay') {
        return;
    }
    if (mode === 'recurring') {
        setPledgePayNowButtonLabel($btn, 'Setup Recurring Payment');
        return;
    }
    const isButton = $btn.prop('tagName') === 'BUTTON';
    const amt = '$' + numberFormat(Math.max(0, online));
    const arrow = '<i class="fa-solid fa-arrow-right ml-2" aria-hidden="true"></i>';
    if (isButton) {
        if (mgrPledgeModalMatchesSaveInsteadOfPayButton(online, tableTotal)) {
            $btn.html('<span class="mgr-pay-btn-inner"><i class="fa-regular fa-floppy-disk mr-2" aria-hidden="true"></i>Save</span>');
            return;
        }
        if (online < 0.005) {
            $btn.html(
                `<span class="mgr-pay-btn-inner d-inline-flex align-items-center"><i class="fa-regular fa-credit-card mr-2" aria-hidden="true"></i>Confirm and Pay ${amt}</span>`
            );
            return;
        }
        $btn.html(
            `<span class="mgr-pay-btn-inner d-inline-flex align-items-center"><i class="fa-regular fa-credit-card mr-2" aria-hidden="true"></i>Confirm and Pay ${amt}</span>`
        );
        return;
    }
    if (mgrPledgeModalMatchesSaveInsteadOfPayButton(online, tableTotal)) {
        setPledgePayNowButtonLabel($btn, 'Save');
    } else {
        setPledgePayNowButtonLabel($btn, 'Confirm and Pay →');
    }
}

/**
 * Same condition as the primary button showing &quot;Save&quot; (credit covers card portion).
 * Refreshes summary math via pledgePayBillUpdateSummary before reading DOM attrs.
 */
function mgrPledgeBillShouldBypassCardValidation($modal) {
    if (!$modal || !$modal.length) {
        return false;
    }
    const payType = $modal.find('#payment_type').val();
    const mode = $modal.find('input[name="payment_mode"]:checked').val();
    if (payType !== 'pay' || mode === 'recurring') {
        return false;
    }
    if (typeof pledgePayBillUpdateSummary === 'function') {
        pledgePayBillUpdateSummary($modal);
    }
    const $summary = $modal.find('#mgr_pledge_summary_section');
    if (!$summary.length) {
        return false;
    }
    return mgrPledgeModalMatchesSaveInsteadOfPayButton(
        $summary.attr('data-online-due'),
        $summary.attr('data-paying-today-total')
    );
}

window.mgrPledgeBillShouldBypassCardValidation = mgrPledgeBillShouldBypassCardValidation;

/** Pause before swapping to credit-success UI (fast DB save feels abrupt without). Override via `window.mgrPledgeBillFullyCoveredSuccessDelayMs`. */
window.mgrPledgeBillFullyCoveredSuccessDelayMs = window.mgrPledgeBillFullyCoveredSuccessDelayMs ?? 2000;

function mgrPledgeBillRunAfterFullyCoveredDelay(callback) {
    const ms = Number(window.mgrPledgeBillFullyCoveredSuccessDelayMs);
    window.setTimeout(callback, Number.isFinite(ms) && ms >= 0 ? ms : 2000);
}

window.mgrPledgeBillRunAfterFullyCoveredDelay = mgrPledgeBillRunAfterFullyCoveredDelay;

function pledgePayBillUpdateSummary($modal) {
    if (!$modal || !$modal.length) {
        return;
    }
    const $summary = $modal.find('#mgr_pledge_summary_section');
    if (!$summary.length) {
        return;
    }
    const payType = $modal.find('#payment_type').val();
    const mode = $modal.find('input[name="payment_mode"]:checked').val();
    if (payType !== 'pay' || mode === 'recurring') {
        return;
    }

    const tableTotal = sumPledgeAmountPaidInputs($modal);

    let balanceApplied = 0;
    if ($modal.find('.mgr-pledge-gateway-stack').length) {
        $modal.find('.mgr-gateway-use-credit:checked').each(function () {
            const $cb = $(this);
            const gid = String($cb.data('gateway-id') || '');
            const raw = String(mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($cb).val() || '').replace(/,/g, '').trim();
            const applyRaw = parseFloat(raw) || 0;
            balanceApplied += Math.max(0, applyRaw);
        });
        balanceApplied = Math.round(balanceApplied * 100) / 100;
    } else {
        const openBalAvailable = getOpenBalanceAvailable();
        const $openActive = $modal.find('#mgr_open_payment_active_state');
        const $openEmpty = $modal.find('#mgr_open_payment_empty_state');
        const openPanelShowsActive = openBalAvailable > 0.005
            && $openActive.length
            && (!$openEmpty.length || $openEmpty.css('display') === 'none')
            && $openActive.css('display') !== 'none';
        const useBal = openPanelShowsActive && $modal.find('#mgr_use_open_payment_balance').prop('checked');
        if (useBal) {
            const applyRaw = parseFloat(String($modal.find('#mgr_open_payment_apply_amount').val()).replace(/,/g, '')) || 0;
            const maxApply = Math.min(tableTotal, openBalAvailable);
            balanceApplied = Math.min(applyRaw, maxApply);
        }
    }

    pledgePayBillUpdateSummaryUI($modal, tableTotal, balanceApplied);
}

function mgrPledgeModalSyncPaymentMethodPanels($modal) {
    const $radios = $modal.find('input[name="mgr_pledge_payment_method_pref"]');
    if (!$radios.length) {
        return;
    }
    const val = $modal.find('input[name="mgr_pledge_payment_method_pref"]:checked').val();
    const $qrWrap = $modal.find('#mgr_pledge_qr_pay_wrap');
    // component fields (saved + new) share same wrapper; toggle the internal blocks
    const $wrap = $modal.find('#mgr_pledge_bill_card_fields_wrap');
    if ($wrap.length) {
        if (val === 'qr') {
            $wrap.hide();
        } else {
            $wrap.show();
        }
        const hasStandardClasses = $wrap.find('.mgr-pay-method-saved, .mgr-pay-method-new').length > 0;
        if (hasStandardClasses) {
            $wrap.find('.mgr-pay-method-saved').toggle(val === 'saved');
            $wrap.find('.mgr-pay-method-new').toggle(val === 'new');
        } else {
            // fallback for legacy markup
            $wrap.find('.save_pay_div').toggle(val === 'saved');
            $wrap.find('.man_pay_div').toggle(val === 'new');
        }
        if (val === 'new' && typeof window.mgrPledgeBillInitExpiryInputMask === 'function') {
            window.mgrPledgeBillInitExpiryInputMask($modal);
        }
    }
    if ($qrWrap.length) {
        $qrWrap.toggle(val === 'qr');
    }

    // Keep native HTML5 validation from firing on hidden manual CC fields.
    const payType = String($modal.find('#payment_type').val() || '');
    const mode = String($modal.find('input[name="payment_mode"]:checked').val() || 'full');
    const manualNew = payType === 'pay' && mode !== 'recurring' && val === 'new';
    const daf = String(window.mgrPledgeBillDafCardType || 'credit');
    const requireZipCvv = daf === 'credit';
    if (typeof window.ccEntrySyncManualCcState === 'function') {
        window.ccEntrySyncManualCcState({
            idPrefix: 'mgr_pledge_bill',
            manualEnabled: manualNew,
            requireBaseManualFields: manualNew,
            requireZipAndCvv: manualNew && requireZipCvv,
        });
    }
}

function mgrPledgeModalCollectPledgeRowsForQr($modal) {
    const pledges = [];
    const $rows = $modal.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr').length
        ? $modal.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr')
        : $modal.find('#set_pledge_payment_table table:first tbody tr');
    $rows.each(function (i) {
        const id = $(this).data('pledge-id');
        const amount = $(this).data('amount-to-pay');
        const gatewayId = $(this).data('gateway-id');
        if (id === undefined || id === null) {
            return;
        }
        pledges.push({
            id,
            amount,
            gateway_id: gatewayId !== undefined && gatewayId !== null ? gatewayId : null,
            cover_surcharge: String($(this).data('force-surcharge')) === '1' || $modal.find('#cover_surcharge').prop('checked'),
            order: i + 1,
        });
    });
    return pledges;
}

/**
 * Apply-amount input for this gateway row: same panel as the "use credit" checkbox.
 * Avoids $root.find('.mgr-gateway-credit-apply[data-gateway-id=…]') returning the first match
 * in the whole subtree when duplicate or stray nodes exist (wrong gateway amount on submit).
 */
function mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($useCb) {
    return $useCb.closest('.mgr-gateway-credit-panel').find('.mgr-gateway-credit-apply').first();
}

function mgrPledgeModalCollectGatewayCreditApply($modal) {
    const out = {};
    $modal.find('.mgr-gateway-use-credit:checked').each(function () {
        const $cb = $(this);
        const gid = String($cb.data('gateway-id') || '');
        if (!gid || gid === '0') {
            return;
        }
        const raw = String(mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($cb).val() || '').replace(/,/g, '').trim();
        const v = parseFloat(raw);
        if (Number.isFinite(v) && v > 0) {
            out[gid] = v.toFixed(2);
        }
    });
    return out;
}

function mgrPledgeModalHasAnyGatewayCreditApplied($modal) {
    const byGateway = mgrPledgeModalCollectGatewayCreditApply($modal);
    return Object.keys(byGateway).some((k) => (parseFloat(byGateway[k]) || 0) > 0);
}

function mgrPledgeModalSyncQrPayButtonText($modal) {
    const $btn = $modal.find('#mgr_pledge_qr_pay_btn');
    if (!$btn.length) {
        return;
    }
    const hasCredit = mgrPledgeModalHasAnyGatewayCreditApplied($modal);
    $btn.text(hasCredit
        ? 'save credit application and pay remainder with QR code'
        : 'use QR code to pay'
    );
}

$(document).on('change input', '#setPledgePaymentModal .mgr-gateway-use-credit, #setPledgePaymentModal .mgr-gateway-credit-apply, #pledge_pay_body[data-mgr-style-pay-ui="1"] .mgr-gateway-use-credit, #pledge_pay_body[data-mgr-style-pay-ui="1"] .mgr-gateway-credit-apply', function () {
    const $shell = pledgePayUiRoot($(this));
    mgrPledgeModalSyncQrPayButtonText($shell);
});

$(document).on('change', '#setPledgePaymentModal input[name="mgr_pledge_payment_method_pref"], #pledge_pay_body[data-mgr-style-pay-ui="1"] input[name="mgr_pledge_payment_method_pref"]', function () {
    const $shell = pledgePayUiRoot($(this));
    mgrPledgeModalSyncPaymentMethodPanels($shell);
    mgrPledgeModalSyncQrPayButtonText($shell);
});

$(document).on('click mousedown', '#setPledgePaymentModal label.mgr-pledge-pay-method-card-disabled, #pledge_pay_body[data-mgr-style-pay-ui="1"] label.mgr-pledge-pay-method-card-disabled', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
});

$(document).on('click', '#setPledgePaymentModal #mgr_pledge_qr_pay_btn, #pledge_pay_body[data-mgr-style-pay-ui="1"] #mgr_pledge_qr_pay_btn', function () {
    const $shell = pledgePayUiRoot($(this));
    const $btn = $(this);
    if (!window.memberPledgePaySetupUrl) {
        if (typeof showErrMsg === 'function') {
            showErrMsg('QR pay is not available right now. Please try again.');
        }
        return;
    }
    if (typeof openQrPayModal !== 'function') {
        if (typeof showErrMsg === 'function') {
            showErrMsg('QR pay modal is not available on this page.');
        }
        return;
    }

    const payload = {
        selected_pledges: mgrPledgeModalCollectPledgeRowsForQr($shell),
        cover_surcharge: $shell.find('#cover_surcharge').prop('checked'),
        use_open_payment_balance: false,
        open_payment_apply_amount: '',
        open_payment_apply_by_gateway: mgrPledgeModalCollectGatewayCreditApply($shell),
        donor_comments: $shell.find('#donor_comments').length ? ($shell.find('#donor_comments').val() || '') : '',
        _token: (window.csrfToken || $('meta[name="csrf-token"]').attr('content') || ''),
    };

    $btn.prop('disabled', true);
    $('#overlay').fadeIn();
    $.ajax({
        url: window.memberPledgePaySetupUrl,
        type: 'POST',
        data: payload,
        success: function (res) {
            const finish = () => {
                $('#overlay').fadeOut();
                $btn.prop('disabled', false);

                if (res && res.success && res.fully_covered) {
                    mgrPledgeBillShellDismissIfModal($shell);
                    if (res.page_info) {
                        const $slot = $('#mgr_index_paging').length ? $('#mgr_index_paging') : $('#index_paging');
                        $slot.empty().html(res.page_info).fadeIn('slow');
                        return;
                    }
                    if (typeof showAlertMsg === 'function') {
                        showAlertMsg(res.msg || 'Account credit applied.');
                    }
                    if (window.pledgePaymentShell === 'page') {
                        window.location.reload();
                    }
                    return;
                }
                if (res && res.success) {
                    mgrPledgeBillShellDismissIfModal($shell);
                    openQrPayModal();
                    return;
                }
                if (typeof showErrMsg === 'function') {
                    showErrMsg(res && (res.error || res.msg) ? (res.error || res.msg) : 'Could not start QR pay. Please try again.');
                }
            };

            if (res && res.success && res.fully_covered) {
                mgrPledgeBillRunAfterFullyCoveredDelay(finish);
                return;
            }
            finish();
        },
        error: function () {
            $('#overlay').fadeOut();
            $btn.prop('disabled', false);
            if (typeof showErrMsg === 'function') {
                showErrMsg('Could not start QR pay. Please try again.');
            }
        }
    });
});

function mgrPledgeModalSyncSavedCardOptionDisabledLook($modal, savedDisabled) {
    const $saved = $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]');
    const $label = $saved.closest('label.mgr-pledge-pay-method-card');
    $label.toggleClass('mgr-pledge-pay-method-card-disabled', !!savedDisabled);
    if (savedDisabled) {
        $saved.prop('checked', false);
        $label.attr('title', 'This user has no saved cards');
    } else {
        $label.removeAttr('title');
    }
}

/**
 * Pledge-bill member AJAX bases must be absolute URLs or root paths. Statement payment page URL is
 * /statement-email-payment/{id}/ — a bare "user-saved-payments-ajax/..." string would resolve under that path.
 */
function mgrPledgeBillMemberAjaxUrl(baseUrl, segment) {
    const base = String(baseUrl || '').trim().replace(/\/+$/, '');
    if (!base) {
        return '';
    }
    const joined =
        segment !== undefined && segment !== null && String(segment).trim() !== ''
            ? `${base}/${encodeURIComponent(String(segment).trim())}`
            : base;
    if (/^https?:\/\//i.test(joined)) {
        return joined;
    }
    const path = joined.startsWith('/') ? joined : `/${joined}`;
    return `${window.location.origin}${path}`;
}

function mgrPledgeModalRefreshSavedCards($modal) {
    // populate the credit-card-entry saved select (mgr_pledge_bill_saved_payment_id)
    const $sel = $modal.find('#mgr_pledge_bill_saved_payment_id');
    if (!$sel.length) {
        return;
    }
    const uid = $modal.find('#payment_user_id').val();
    $sel.empty().append($('<option>', { value: '', text: 'Loading…' }));
    $modal.find('#mgr_pledge_no_saved_cards_msg').hide();
    if (!uid || !window.managerSavedPaymentsAjaxBaseUrl) {
        $sel.empty();
        mgrPledgeModalSyncPaymentMethodPanels($modal);
        return;
    }
    const url = mgrPledgeBillMemberAjaxUrl(window.managerSavedPaymentsAjaxBaseUrl, uid);
    if (!url) {
        $sel.empty();
        mgrPledgeModalSyncPaymentMethodPanels($modal);
        return;
    }
    $.getJSON(url, (res) => {
        $sel.empty();
        if (res.success && Array.isArray(res.saved_cards) && res.saved_cards.length) {
            res.saved_cards.forEach((c) => {
                const def = (c.default === 1 || c.default === true) ? ' (Default)' : '';
                $sel.append($('<option>', { value: c.id, text: `${c.cc_info || ''}${def}` }));
            });
            $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]').prop('disabled', false);
            $modal.find('input[name="mgr_pledge_payment_method_pref"][value="new"]').prop('disabled', false);
            mgrPledgeModalSyncSavedCardOptionDisabledLook($modal, false);
            if (!$modal.find('input[name="mgr_pledge_payment_method_pref"]:checked').length) {
                $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]').prop('checked', true);
            }
        } else {
            $modal.find('input[name="mgr_pledge_payment_method_pref"][value="new"]').prop('checked', true).prop('disabled', false);
            $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]').prop('disabled', true);
            mgrPledgeModalSyncSavedCardOptionDisabledLook($modal, true);
        }
        mgrPledgeModalSyncPaymentMethodPanels($modal);
    }).fail(() => {
        $sel.empty();
        $modal.find('#mgr_pledge_no_saved_cards_msg').show().text('There was an error loading saved cards. Please reload the page and try again.');
        $modal.find('input[name="mgr_pledge_payment_method_pref"][value="new"]').prop('checked', true).prop('disabled', false);
        $modal.find('input[name="mgr_pledge_payment_method_pref"][value="saved"]').prop('disabled', true);
        mgrPledgeModalSyncSavedCardOptionDisabledLook($modal, true);
        mgrPledgeModalSyncPaymentMethodPanels($modal);
    });
}

/** Per-gateway pool labels; hides mgr-gateway-credit-row and shows mgr-gateway-no-credit-note when pool is ~0. */
function mgrPledgeModalSyncGatewayCreditPanelDisplay($modal) {
    $modal.find('.mgr-gateway-credit-available').each(function () {
        const gid = String($(this).data('gateway-id') || '');
        const pool = parseFloat((window.openBalanceByGateway || {})[gid] ?? (window.openBalanceByGateway || {})[Number(gid)] ?? 0) || 0;
        $(this).text(typeof numberFormat === 'function' ? numberFormat(pool) : pool.toFixed(2));
        const $panel = $(this).closest('.mgr-gateway-credit-panel');
        const noCredit = pool <= 0.005;
        $panel.toggleClass('mgr-gateway-no-credit', noCredit);
        $panel.find('.mgr-gateway-credit-row').toggle(!noCredit);
        $panel.find('.mgr-gateway-no-credit-note').toggle(noCredit);
    });
}

function refreshManagerPledgeModalOpenPaymentSection($root) {
    const $pledgeBody = $root.is('#pledge_pay_body') ? $root : $root.find('#pledge_pay_body').first();
    if (!$pledgeBody.length) {
        return;
    }
    const uid = $pledgeBody.find('#payment_user_id').val();
    mgrPledgeModalRefreshSavedCards($pledgeBody);
    window.openBalanceByGateway = {};
    // Immediately reflect "no credit" state while balance AJAX loads.
    // Otherwise UI can briefly show "Apply … $0.00 available" which is misleading.
    mgrPledgeModalSyncGatewayCreditPanelDisplay($pledgeBody);
    if ($pledgeBody.find('#mgr_use_open_payment_balance').length) {
        $pledgeBody.find('#mgr_use_open_payment_balance').prop('checked', false);
    }
    if ($pledgeBody.find('#mgr_open_payment_apply_amount').length) {
        $pledgeBody.find('#mgr_open_payment_apply_amount').val('').prop('disabled', true);
    }
    if ($pledgeBody.find('#mgr_open_payment_amount_wrap').length) {
        $pledgeBody.find('#mgr_open_payment_amount_wrap').addClass('mgr-open-payment-apply-muted');
    }
    $pledgeBody.find('.mgr-gateway-use-credit').prop('checked', false);
    $pledgeBody.find('.mgr-gateway-credit-apply').val('').prop('disabled', true);
    $pledgeBody.find('.mgr-gateway-credit-panel').addClass('mgr-gateway-credit-inactive');
    $pledgeBody.find('#mgr_pledge_fully_covered_row').hide();

    mgrPledgeModalSyncSummaryVisibility($pledgeBody);

    if (!uid || !window.managerOpenPaymentBalanceBaseUrl) {
        setOpenBalanceAvailable(0, $pledgeBody);
        mgrPledgeModalSyncGatewayCreditPanelDisplay($pledgeBody);
        mgrPledgeModalSyncOpenPaymentStates($pledgeBody);
        pledgePayBillUpdateSummary($pledgeBody);
        updatePledgePayNowButtonEnabledState($pledgeBody);
        return;
    }
    const url = mgrPledgeBillMemberAjaxUrl(window.managerOpenPaymentBalanceBaseUrl, uid);
    if (!url) {
        setOpenBalanceAvailable(0, $pledgeBody);
        mgrPledgeModalSyncGatewayCreditPanelDisplay($pledgeBody);
        mgrPledgeModalSyncOpenPaymentStates($pledgeBody);
        pledgePayBillUpdateSummary($pledgeBody);
        updatePledgePayNowButtonEnabledState($pledgeBody);
        return;
    }
    $.getJSON(url, (res) => {
        window.openBalanceByGateway = (res.success && res.by_gateway) ? res.by_gateway : {};
        let sumPools = 0;
        Object.keys(window.openBalanceByGateway || {}).forEach((k) => {
            sumPools += parseFloat(window.openBalanceByGateway[k]) || 0;
        });
        const t = (res.success && parseFloat(res.total_remaining)) || sumPools || 0;
        setOpenBalanceAvailable(t, $pledgeBody);
        mgrPledgeModalSyncGatewayCreditPanelDisplay($pledgeBody);
        mgrPledgeModalSyncOpenPaymentStates($pledgeBody);
        pledgePayBillUpdateSummary($pledgeBody);
        updatePledgePayNowButtonEnabledState($pledgeBody);
    }).fail(() => {
        window.openBalanceByGateway = {};
        setOpenBalanceAvailable(0, $pledgeBody);
        mgrPledgeModalSyncGatewayCreditPanelDisplay($pledgeBody);
        mgrPledgeModalSyncOpenPaymentStates($pledgeBody);
        pledgePayBillUpdateSummary($pledgeBody);
        updatePledgePayNowButtonEnabledState($pledgeBody);
    });
}

function mgrPledgeModalSyncOpenPaymentVisibility($modal) {
    mgrPledgeModalSyncSummaryVisibility($modal);
    const payType = $modal.find('#payment_type').val();
    const mode = $modal.find('input[name="payment_mode"]:checked').val();
    updatePledgePayNowButtonEnabledState($modal);
    if (payType !== 'pay' || mode === 'recurring') {
        // Recurring should hide open-credit UI immediately.
        mgrPledgeModalSyncOpenPaymentStates($modal);
        return;
    }
    mgrPledgeModalSyncOpenPaymentStates($modal);
    pledgePayBillUpdateSummary($modal);
}

function mgrPledgeModalRecalcOpenApplyCap($modal) {
    if ($modal.find('.mgr-pledge-gateway-stack').length) {
        $modal.find('.mgr-gateway-use-credit:checked').each(function () {
            const $cb = $(this);
            const gid = String($cb.data('gateway-id') || '');
            const $inp = mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($cb);
            if (!$inp.length) {
                return;
            }
            const pool = parseFloat((window.openBalanceByGateway || {})[gid] ?? (window.openBalanceByGateway || {})[Number(gid)] ?? 0) || 0;
            const groupPay = sumPledgeAmountPaidForGateway($modal, gid);
            const maxApply = Math.min(pool, groupPay);
            $inp.attr('max', maxApply);
            const cur = parseFloat(String($inp.val()).replace(/,/g, '')) || 0;
            if (cur > maxApply + 0.0001) {
                $inp.val(maxApply > 0 ? maxApply.toFixed(2) : '');
            }
        });
        pledgePayBillUpdateSummary($modal);
        updatePledgePayNowButtonEnabledState($modal);
        return;
    }
    const amtDue = sumPledgeAmountPaidInputs($modal);
    const openAvail = getOpenBalanceAvailable();
    const $inp = $modal.find('#mgr_open_payment_apply_amount');
    if (window.openPaymentBalanceApply) {
        window.openPaymentBalanceApply.capApplyInput($inp, openAvail, amtDue);
    } else {
        const max = Math.min(amtDue, openAvail);
        $inp.attr('max', max);
    }
    pledgePayBillUpdateSummary($modal);
    updatePledgePayNowButtonEnabledState($modal);
}

$(document).on('change', '#setPledgePaymentModal input[name="payment_mode"], #pledge_pay_body[data-mgr-style-pay-ui="1"] input[name="payment_mode"]', function () {
    const $shell = pledgePayUiRoot($(this));
    mgrPledgeModalSyncOpenPaymentVisibility($shell);
    mgrPledgeModalSyncPaymentTableFooter($shell);
    mgrPledgeModalSyncPaymentMethodPanels($shell);
});

// Component-driven dispatch: credit-card-entry triggers behavior under the same id-prefix
// used in markup. We look up the active pledge-pay UI root from the visible bill tile so the
// zip-row toggle and panel-sync target the right shell.
window.dafCardTypeHandlers = window.dafCardTypeHandlers || {};
window.dafCardTypeHandlers['mgr_pledge_bill_'] = function (type) {
    const cardType = String(type || 'credit');
    window.mgrPledgeBillDafCardType = cardType;
    const $el = $('#mgr_pledge_bill_cc_div:visible').first();
    if (!$el.length) return;
    const $modal = pledgePayUiRoot($el);
    $modal.find('.mgr-pledge-bill-zip-row').toggle(cardType === 'credit');
    mgrPledgeModalSyncPaymentMethodPanels($modal);
};

window.mgrPledgeBillInitExpiryInputMask = function ($modal) {
    if (!$modal?.length || typeof $.fn.inputmask !== 'function' || window.kiosk_validated) {
        return;
    }
    const $month = $modal.find('#mgr_pledge_bill_expiry_month');
    const $year = $modal.find('#mgr_pledge_bill_expiry_year');
    if ($month.length && !$month.data('inputmask')) {
        $month.inputmask('9[9]');
    }
    if ($year.length && !$year.data('inputmask')) {
        $year.inputmask('99');
    }
};

window.mgrPledgeBillValidateNewCard = function ($modal) {
    const errors = [];
    const daf = window.mgrPledgeBillDafCardType || 'credit';
    const name = String($modal.find('#mgr_pledge_bill_name').val() || '').trim();
    if (!name) {
        errors.push('Enter the name on the card.');
    }
    const cardVal = String($modal.find('#mgr_pledge_bill_card').val() || '');
    const digits = cardVal.replace(/ /g, '');
    if (daf === 'credit') {
        if (!digits.match(/^3[47]/)) {
            if (digits.length !== 16) {
                errors.push('Card number should be 16 digits (Visa/Mastercard).');
            }
        } else if (digits.length !== 15) {
            errors.push('American Express card number should be 15 digits.');
        }
    } else if (daf === 'pledger' || daf === 'donors_fund' || daf === 'ojc') {
        const dafLenMsg = typeof dafCardNumberTooShortMessage === 'function'
            ? dafCardNumberTooShortMessage(digits)
            : (digits.length < 14 ? 'This card number is too short. OJC, Pledger, and Donors Fund numbers must be at least 14 digits.' : '');
        if (dafLenMsg) {
            errors.push(dafLenMsg);
        }
    }
    const cvv = String($modal.find('#mgr_pledge_bill_cvv2').val() || '');
    if (daf === 'credit') {
        if (!digits.match(/^3[47]/) && cvv.length !== 3) {
            errors.push('CVV must be 3 digits.');
        }
        if (digits.match(/^3[47]/) && cvv.length !== 4) {
            errors.push('CVV must be 4 digits for American Express.');
        }
    }
    const emRaw = String($modal.find('#mgr_pledge_bill_expiry_month').val() || '').replace(/_/g, '').trim();
    const eyRaw = String($modal.find('#mgr_pledge_bill_expiry_year').val() || '').replace(/_/g, '').trim();
    const em = parseInt(emRaw, 10);
    if (!/^\d{1,2}$/.test(emRaw) || !Number.isFinite(em) || em < 1 || em > 12) {
        errors.push('Enter a valid expiration month (1–12).');
    }
    const curYear = new Date().getFullYear() % 100;
    const curMonth = new Date().getMonth() + 1;
    if (!/^\d{2}$/.test(eyRaw)) {
        errors.push('Enter a valid two-digit expiration year (e.g. 26 for 2026).');
    } else {
        const ey = parseInt(eyRaw, 10);
        if (ey < curYear || (ey === curYear && em < curMonth)) {
            errors.push('Card appears to be expired.');
        }
    }
    if (daf === 'credit') {
        const zip = String($modal.find('#mgr_pledge_bill_avs_zip').val() || '').trim();
        if (!/^((\d{5}-\d{4})|(\d{5})|([A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d))$/.test(zip)) {
            errors.push('Enter a valid US or Canadian postal code.');
        }
    }
    return { ok: errors.length === 0, errors };
};

$(document).on('change', '#mgr_use_open_payment_balance', function () {
    const $root = $(this).closest('#pledge_pay_body');
    if (!$root.length) {
        return;
    }
    const $applyInput = $root.find('#mgr_open_payment_apply_amount');

    const isChecked = $(this).prop('checked');

    if (isChecked) {
        mgrPledgeModalSyncOpenPaymentApplyControls($root);

        mgrPledgeModalRecalcOpenApplyCap($root);

        const amtDue = sumPledgeAmountPaidInputs($root);
        const openAvail = getOpenBalanceAvailable();
        if (window.openPaymentBalanceApply) {
            window.openPaymentBalanceApply.autofillMaxIfEmpty($applyInput, openAvail, amtDue);
        } else {
            const hasNoValue = $applyInput.val() === '' || $applyInput.val() === null;
            if (hasNoValue) {
                const defaultApplyAmount = Math.min(amtDue, openAvail);
                if (defaultApplyAmount > 0) {
                    $applyInput.val(defaultApplyAmount.toFixed(2));
                }
            }
        }

        mgrPledgeModalRecalcOpenApplyCap($root);

    } else {
        $applyInput.val('');
        mgrPledgeModalSyncOpenPaymentApplyControls($root);
        pledgePayBillUpdateSummary($root);
        updatePledgePayNowButtonEnabledState($root);
    }
});

$(document).on('input change', '#mgr_open_payment_apply_amount', function () {
    const $root = $(this).closest('#pledge_pay_body');
    if ($root.length) {
        mgrPledgeModalRecalcOpenApplyCap($root);
    }
});

$(document).on('change', '.mgr-gateway-use-credit', function () {
    const $root = pledgePayUiRoot($(this));
    const $panel = $(this).closest('.mgr-gateway-credit-panel');
    const $inp = $panel.find('.mgr-gateway-credit-apply');
    const isChecked = $(this).prop('checked');
    if (isChecked) {
        $inp.prop('disabled', false);
        $panel.removeClass('mgr-gateway-credit-inactive');
        mgrPledgeModalRecalcOpenApplyCap($root);
        const gid = String($(this).data('gateway-id') || '');
        const pool = parseFloat((window.openBalanceByGateway || {})[gid] ?? (window.openBalanceByGateway || {})[Number(gid)] ?? 0) || 0;
        const groupPay = sumPledgeAmountPaidForGateway($root, gid);
        if ($inp.val() === '' || $inp.val() === null) {
            const def = Math.min(pool, groupPay);
            if (def > 0) {
                $inp.val(def.toFixed(2));
            }
        }
        mgrPledgeModalRecalcOpenApplyCap($root);
    } else {
        $inp.val('').prop('disabled', true);
        $panel.addClass('mgr-gateway-credit-inactive');
        pledgePayBillUpdateSummary($root);
        updatePledgePayNowButtonEnabledState($root);
    }
});

$(document).on('input change', '.mgr-gateway-credit-apply', function () {
    const $root = pledgePayUiRoot($(this));
    mgrPledgeModalRecalcOpenApplyCap($root);
});

// this is the second page of a pledge payment, with the payment method types (saved card / new card / qr code)
function openPledgePayPage() {
    $pledgePayBody = $('#pledge_pay_body')
    const isRecurring = getPaymentMode($pledgePayBody) === 'recurring';
    if (isRecurring && isPledgePaySubmitInProgress($pledgePayBody)) {
        return false;
    }
    if (isRecurring) {
        setPledgePaySubmitInProgress($pledgePayBody, true);
    }
    const collectPledges = () => {
        const pledges = [];
        const paymentMode = getPaymentMode($pledgePayBody);
        const $rows = $pledgePayBody.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr').length
            ? $pledgePayBody.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr')
            : $pledgePayBody.find('#set_pledge_payment_table table:first tbody tr');
        $rows.each(function (i) {
            const $row = $(this);
            const id = $(this).data('pledge-id');
            const amount = $(this).data('amount-to-pay');
            const gatewayId = $(this).data('gateway-id');
            if (id === undefined || amount === undefined) {
                return;
            }
            // Always use shared statement-selection logic so totals + submission match.
            if (shouldSkipAmountToPayRowForStatement($row, $pledgePayBody)) {
                return;
            }
            pledges.push({
                id,
                amount,
                gateway_id: gatewayId !== undefined && gatewayId !== null ? gatewayId : null,
                cover_surcharge: String($(this).data('force-surcharge')) === '1' || $('#cover_surcharge').prop('checked'),
                order: i + 1
            });
        });
        return pledges;
    };

    syncPledgeAmountToPayInputStyles($pledgePayBody);
    if (pledgeAmountToPayRowsInvalid($pledgePayBody)) {
        $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html(`<li><i class="fa-regular fa-circle-x"></i>&nbsp;The amount is required.  Please fix the amounts highlighted in red.</li>`);
        $pledgePayBody.find('#ajaxMsgMatanahAmt').show();

        setTimeout(() => {
            $("#ajaxMsgMatanahAmt").fadeOut();
        }, 3000);

        $pledgePayBody.find('#matanah_message').removeClass("alert-success");
        $pledgePayBody.find('#matanah_message').addClass("alert-danger");
        if (isRecurring) {
            setPledgePaySubmitInProgress($pledgePayBody, false);
        }
        return false;
    }

    if (isRecurring && blockPledgeScheduleStartDateIfNotFuture($pledgePayBody)) {
        setPledgePaySubmitInProgress($pledgePayBody, false);
        return false;
    }

    const collectGatewayCreditApplyMember = () => {
        const out = {};
        $pledgePayBody.find('.mgr-gateway-use-credit:checked').each(function () {
            const $cb = $(this);
            const gid = String($cb.data('gateway-id') || '');
            if (!gid || gid === '0') {
                return;
            }
            const raw = String(mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($cb).val() || '').replace(/,/g, '').trim();
            const v = parseFloat(raw);
            if (Number.isFinite(v) && v > 0) {
                out[gid] = v.toFixed(2);
            }
        });
        return out;
    };

    let postData = {
        selected_pledges: collectPledges(),
        cover_surcharge: $pledgePayBody.find('#cover_surcharge').prop('checked'),
        congregation_id: window.congregation_id,
        use_open_payment_balance: $pledgePayBody.find('#mgr_use_open_payment_balance').length
            ? $pledgePayBody.find('#mgr_use_open_payment_balance').prop('checked')
            : false,
        open_payment_apply_amount: $pledgePayBody.find('#mgr_open_payment_apply_amount').length
            ? $pledgePayBody.find('#mgr_open_payment_apply_amount').val()
            : '',
        open_payment_apply_by_gateway: collectGatewayCreditApplyMember(),
        _token: getCsrfToken(),
    };

    const paymentMode = getPaymentMode($pledgePayBody);


    if (paymentMode === 'recurring') {
        postData = {
            ...postData,
            frequency_id: $pledgePayBody.find('select[name="frequency"] option:selected').attr('id'),
            duration: $pledgePayBody.find('select[name="duration"]').val()
                || $pledgePayBody.find('#pledge_payment_duration').val(),
            run_today: $pledgePayBody.find('input[name="run_today"]').is(':checked') ? '1' : '0',
            pledge_start_date: $pledgePayBody.find('input[name="pledge_start_date"]').val(),
            pledge_installment_amount: $pledgePayBody.find('input[name="installment_amount"]').val(),
            surcharge_installment_amount: $pledgePayBody.find('input[name="surcharge_installment_amount"]').val(),
            process_type: 'token',
        };
    }

    localStorage.clear();

    $.ajax({
        url: "/member-pledge-pay-setup",
        type: "POST",
        data: postData,
        success: function (data) {
            if (data.success === false) {
                if (isRecurring) {
                    setPledgePaySubmitInProgress($pledgePayBody, false);
                }
                showErrMsg(data.error || 'Unable to continue. Please try again.');
                return;
            }
            if (data.fully_covered) {
                const showCreditSuccess = () => {
                    if (data.page_info) {
                        $("#index_paging").empty().html(data.page_info).fadeIn('slow');
                        return;
                    }
                    if (typeof showAlertMsg === 'function') {
                        showAlertMsg(data.msg || 'Account credit applied.');
                    }
                    if (typeof openIndexPage === 'function') {
                        openIndexPage();
                    } else {
                        window.location.reload();
                    }
                };
                mgrPledgeBillRunAfterFullyCoveredDelay(showCreditSuccess);
                return;
            }
            $("#index_paging").empty().html(data.page_info).fadeIn('slow');
        },
        error: function () {
            if (isRecurring) {
                setPledgePaySubmitInProgress($pledgePayBody, false);
            }
            showErrMsg("A time out error occurred, please try again");
            openIndexPage();
        }
    });
}

function getPaymentMode($container) {
    return $container.find('input[name="payment_mode"]:checked').val()
        || $container.find('#payment_mode').val();
}

function isStatementEmailPayment($container) {
    if (window.statementEmailPayment === true) {
        return true;
    }
    return $container.find('#opener_type').val() === 'statement';
}

function shouldFilterStatementPledges($container, paymentMode) {
    if (!isStatementEmailPayment($container)) {
        return false;
    }
    if (paymentMode === 'recurring') {
        return false;
    }
    const payType = $container.find('#payment_type').val();
    return payType !== 'mark';
}

function hasPendingMatanah($container) {
    const count = parseInt($container.find('#matanah_ct').val(), 10);
    return !Number.isNaN(count) && count > 0;
}

/** Modal or #pledge_pay_body: root used to find #pay_now_button and pledge table. */
function pledgePayUiRoot($anyDescendant) {
    const $modal = $anyDescendant.closest('#setPledgePaymentModal');
    if ($modal.length) {
        return $modal;
    }
    const $body = $anyDescendant.closest('#pledge_pay_body');
    return $body.length ? $body : $anyDescendant;
}

function getAmountToPayTableBodyRows($root) {
    const $wrap = $root.find('#set_pledge_payment_table');
    if ($wrap.find('.mgr-pledge-gateway-payment-table').length) {
        return $wrap.find('.mgr-pledge-gateway-payment-table tbody tr');
    }
    const $table = $root.find('#set_pledge_payment_table table:first, #set_payment_table').first();
    if (!$table.length) {
        return $();
    }
    return $table.find('tbody tr');
}

function shouldSkipAmountToPayRowForStatement($row, $root) {
    const paymentMode = getPaymentMode($root);
    if (!shouldFilterStatementPledges($root, paymentMode)) {
        return false;
    }
    const $cb = $row.find('input.statement-pledge-select');
    return $cb.length > 0 && !$cb.is(':checked');
}

/**
 * One row: invalid if this pledge is included in the payment and the amount to pay is missing or <= 0.
 * Uses the input when present; otherwise falls back to data-amount-to-pay
 */
function isPledgeAmountToPayRowInvalid($row, $root) {
    if (shouldSkipAmountToPayRowForStatement($row, $root)) {
        return false;
    }
    const $inp = $row.find('input[name="amount_paid"]');
    if ($inp.length && $inp.prop('disabled')) {
        return false;
    }
    const rawValue = $inp.length ? $inp.val() : $row.data('amount-to-pay');
    const raw = String(rawValue ?? '').replace(/,/g, '').trim();
    const num = parseFloat(raw);
    return raw === '' || !Number.isFinite(num) || num <= 0;
}

/**
 * True if any included pledge row fails isPledgeAmountToPayRowInvalid (member pay + manager modal).
 */
function pledgeAmountToPayRowsInvalid($root) {
    if (getPaymentMode($root) === 'recurring') {
        return false;
    }
    let invalid = false;
    getAmountToPayTableBodyRows($root).each(function () {
        if (isPledgeAmountToPayRowInvalid($(this), $root)) {
            invalid = true;
            return false;
        }
    });
    return invalid;
}

function syncPledgeAmountToPayInputStyles($root) {
    if (getPaymentMode($root) === 'recurring') {
        return;
    }
    getAmountToPayTableBodyRows($root).each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $root)) {
            $row.find('input[name="amount_paid"]').css('border-color', '');
            return;
        }
        const $inp = $row.find('input[name="amount_paid"]');
        if (!$inp.length || $inp.prop('disabled')) {
            return;
        }
        $inp.css('border-color', isPledgeAmountToPayRowInvalid($row, $root) ? 'red' : '');
    });
}

/**
 * True when "use open balance" is on and the apply amount exceeds the pledge "paying today" total
 * (#mgr_summary_paying_today / sum of amount_paid inputs).
 */
function pledgeOpenApplyAmountExceedsPayingToday($root) {
    const payType = $root.find('#payment_type').val();
    const mode = $root.find('input[name="payment_mode"]:checked').val();
    if (payType !== 'pay' || mode === 'recurring') {
        return false;
    }
    const tableTotal = sumPledgeAmountPaidInputs($root);

    if ($root.find('.mgr-pledge-gateway-stack').length) {
        let applySum = 0;
        let invalid = false;
        $root.find('.mgr-gateway-use-credit:checked').each(function () {
            const $cb = $(this);
            const gid = String($cb.data('gateway-id') || '');
            const $inp = mgrPledgeBillGatewayCreditApplyInputFromUseCheckbox($cb);
            if (!$inp.length || $inp.prop('disabled')) {
                return;
            }
            const raw = String($inp.val() ?? '').replace(/,/g, '').trim();
            if (raw === '') {
                return;
            }
            const applyRaw = parseFloat(raw);
            if (!Number.isFinite(applyRaw)) {
                invalid = true;
                return false;
            }
            applySum += applyRaw;
            const pool = parseFloat((window.openBalanceByGateway || {})[gid] ?? (window.openBalanceByGateway || {})[Number(gid)] ?? 0) || 0;
            const groupPay = sumPledgeAmountPaidForGateway($root, gid);
            if (applyRaw > groupPay + 0.005 || applyRaw > pool + 0.005) {
                invalid = true;
                return false;
            }
        });
        if (invalid) {
            return true;
        }
        return applySum > tableTotal + 0.005;
    }

    const openBalAvailable = getOpenBalanceAvailable();
    const hasInteractiveOpen =
        openBalAvailable > 0 && $root.find('#mgr_open_payment_active_state').is(':visible');
    if (!hasInteractiveOpen || !$root.find('#mgr_use_open_payment_balance').prop('checked')) {
        return false;
    }
    const $inp = $root.find('#mgr_open_payment_apply_amount');
    if (!$inp.length || $inp.prop('disabled')) {
        return false;
    }
    const raw = String($inp.val() ?? '').replace(/,/g, '').trim();
    if (raw === '') {
        return false;
    }
    const applyRaw = parseFloat(raw);
    if (!Number.isFinite(applyRaw)) {
        return false;
    }
    return applyRaw > tableTotal + 0.005;
}

function setPledgePaySubmitInProgress($root, inProgress) {
    const $btn = $root.find('#pay_now_button');
    if (!$btn.length) {
        return;
    }
    $btn.data('submitInProgress', !!inProgress);
    updatePledgePayNowButtonEnabledState($root);
}

function isPledgePaySubmitInProgress($root) {
    return !!$root.find('#pay_now_button').data('submitInProgress');
}

function updatePledgePayNowButtonEnabledState($anyDescendant) {
    const $root = pledgePayUiRoot($anyDescendant);
    const $btn = $root.find('#pay_now_button');
    const $openApply = $root.find('#mgr_open_payment_apply_amount');
    if (!$btn.length) {
        return;
    }
    if ($btn.data('submitInProgress')) {
        $btn.prop('disabled', true);
        return;
    }
    if (hasPendingMatanah($root)) {
        $btn.prop('disabled', true);
        if ($openApply.length) {
            $openApply.css('border-color', '');
        }
        return;
    }
    if (getPaymentMode($root) === 'recurring') {
        $btn.prop('disabled', !!$btn.data('statementSelectDisabled'));
        if ($openApply.length) {
            $openApply.css('border-color', '');
        }
        return;
    }
    syncPledgeAmountToPayInputStyles($root);
    const amountInvalid = pledgeAmountToPayRowsInvalid($root);
    $btn.data('pledgeAmountInvalid', amountInvalid);
    const statementBlocked = !!$btn.data('statementSelectDisabled');
    const openApplyExceedsPayingToday = pledgeOpenApplyAmountExceedsPayingToday($root);
    if ($openApply.length) {
        $openApply.css('border-color', openApplyExceedsPayingToday ? 'red' : '');
    }
    if ($root.find('.mgr-pledge-gateway-stack').length) {
        $root.find('.mgr-gateway-credit-apply').css('border-color', openApplyExceedsPayingToday ? 'red' : '');
    }
    $btn.prop('disabled', statementBlocked || amountInvalid || openApplyExceedsPayingToday);
}

function syncPledgeAmountToPayValidation($anyDescendant) {
    updatePledgePayNowButtonEnabledState($anyDescendant);
}

function updateStatementPledgeSelectionValidation($container) {
    if (!$container || !$container.length) {
        return;
    }

    const $fullPayment = $container.find('#full_payment');
    const $payNowButton = $container.find('#pay_now_button');

    if (!$payNowButton.length) {
        return;
    }

    const $checkboxes = $container.find('input.statement-pledge-select');
    const $enabledVisible = $checkboxes.filter(':visible').filter(function () {
        return !$(this).prop('disabled');
    });

    const requiresSelection = $fullPayment.length
        && $fullPayment.is(':checked')
        && $enabledVisible.length > 0;

    if (!requiresSelection) {
        $payNowButton.removeData('statementSelectDisabled');
        updatePledgePayNowButtonEnabledState($container);
        return;
    }

    const anyChecked = $enabledVisible.filter(':checked').length > 0;

    if (!anyChecked) {
        $payNowButton.data('statementSelectDisabled', true);
        updatePledgePayNowButtonEnabledState($container);
        return;
    }

    $payNowButton.removeData('statementSelectDisabled');
    updatePledgePayNowButtonEnabledState($container);
}

function openMembersPayOneBillPage(pledge_id) {
    let pledge = window.pledgeObj[pledge_id];
    const pledgeDate = pledge.date_pledged || pledge.pledge_date || null;
    const parsedAmount = parseFloat(pledge.amount ?? pledge.format_amount ?? 0);
    const parsedBalance = parseFloat(pledge.balance_due ?? pledge.format_balance_due ?? 0);
    let pledges = [{
        id: pledge.pledge_id ?? pledge.id,
        user_name: pledge.user_name ?? pledge.member_name ?? null,
        user_id: pledge.user_id ?? null,
        user_email: pledge.user_email ?? pledge.email ?? null,
        campaign: pledge.campaign,
        description: pledge.description ?? '',
        date_pledged: formatPledgeDateUsDisplay(pledgeDate),
        amount: parsedAmount.toFixed(2),
        balance_due: pledge.balance_due ?? parsedBalance,
        format_balance_due: parsedBalance.toFixed(2),
        format_amount: parsedAmount.toFixed(2),
        matanah: pledge.matanah,
        force_surcharge: pledge.force_surcharge,
        gateway_id: pledge.gateway_id
    }];
    window.payBillModalSelectedPledges = pledges;

    updateMultiGatewayPaymentModeWarning(
        $('#pledge_pay_body'),
        pledges,
        $('#pledge_pay_body').find('#payment_type').val() || 'pay'
    );
    let result = renderPledgePaymentTable(pledges, false, $('#pledge_pay_body'));

    $('#pledge_ids').val(pledge_id);
    $('#total_amount').val(result.totalAmount);

    if (result.matanahFound) {
        $("#cover_surcharge").prop('disabled', true);
    }
    updatePledgePayNowButtonEnabledState($('#pledge_pay_body'));

}

function runSelectedMemberBills(checkedCheckboxesValues) {
    let pledges = checkedCheckboxesValues.map(id => {
        let pledge = window.pledgeObj[id];
        return formatPledgeForPaymentTable(pledge, false);
    }).filter(Boolean);

    window.payBillModalSelectedPledges = pledges;

    updateMultiGatewayPaymentModeWarning(
        $('#pledge_pay_body'),
        pledges,
        $('#pledge_pay_body').find('#payment_type').val() || 'pay'
    );
    let result = renderPledgePaymentTable(pledges, false, $('#pledge_pay_body'));

    $('#pledge_ids').val(checkedCheckboxesValues);
    $('#total_amount').val(result.totalAmount);

    if (result.matanahFound) {
        $("#cover_surcharge").prop('disabled', true);
    }
    updatePledgePayNowButtonEnabledState($('#pledge_pay_body'));

}

/**
 * Member pledgeObj uses m/d/Y strings; checkbox payloads may use ISO dates.
 * Avoid `new Date('05/04/2026')` which is not reliably parsed across browsers.
 */
function formatPledgeDateUsDisplay(raw) {
    if (raw == null || raw === '') {
        return null;
    }
    const s = String(raw).trim();
    const usSlash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(s);
    if (usSlash) {
        const month = parseInt(usSlash[1], 10);
        const day = parseInt(usSlash[2], 10);
        const year = parseInt(usSlash[3], 10);
        const dt = new Date(year, month - 1, day);
        return Number.isNaN(dt.getTime()) ? s : dt.toLocaleDateString('en-US');
    }
    const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (iso) {
        const dt = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
        return Number.isNaN(dt.getTime()) ? null : dt.toLocaleDateString('en-US');
    }
    const dt = new Date(s);
    return Number.isNaN(dt.getTime()) ? s : dt.toLocaleDateString('en-US');
}

function formatPledgeForPaymentTable(pledge, isManagerView = false) {
    if (!pledge) {
        return null;
    }

    const pledgeDate = pledge.date_pledged ?? pledge.pledge_date ?? null;
    const parsedAmount = parseFloat(pledge.amount ?? pledge.format_amount ?? 0);
    const parsedBalance = parseFloat(pledge.balance_due ?? pledge.format_balance_due ?? 0);
    const dateValue = formatPledgeDateUsDisplay(pledgeDate);

    return {
        id: pledge.pledge_id ?? pledge.id,
        user_name: pledge.user_name ?? pledge.member_name ?? null,
        user_id: pledge.user_id ?? null,
        user_email: pledge.user_email ?? pledge.email ?? null,
        campaign: pledge.campaign,
        description: pledge.description ?? '',
        date_pledged: dateValue,
        pledge_date: dateValue,
        amount: parsedAmount.toFixed(2),
        balance_due: pledge.balance_due ?? parsedBalance,
        format_balance_due: parsedBalance.toFixed(2),
        format_amount: parsedAmount.toFixed(2),
        matanah: pledge.matanah,
        force_surcharge: pledge.force_surcharge,
        gateway_id: pledge.gateway_id,
        gateway_title: pledge.gateway_title ?? null,
        gateway_icon_class: pledge.gateway_icon_class ?? null,
    };
}

function saveMatanahAmount(pledge_id) {
    $pledgePayBody = $('#pledge_pay_body')
    //here we have to save the amount to the pledge and then after refresh the screen, table and turn pay now button on.
    //re-hide the error message in case they had one and re-submit it
    $pledgePayBody.find('#ajaxMsgMatanahAmt').hide();

    //first we need to see if the box is empty
    workingAmount = $("input[id='matanah_amount[" + pledge_id + "]']");
    //change the box back to brown outline and if error, will turn red again
    workingAmount.css("border-color", "#9F843B");

    matanahErr = false;
    if (workingAmount.val() === "") {
        //set the error message and return false to fix below
        matanahErr = true;
        $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html('<li><i class="fa-regular fa-circle-x"></i>&nbsp;The matanah amount you are saving can\'t be empty</li>');

    }
    if (workingAmount.val() < window.min_trans_amt) {
        //set the error message and return false to fix below
        matanahErr = true;
        $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html(`<li><i class="fa-regular fa-circle-x"></i>&nbsp;The matanah amount you are entering has to be more than $${window.min_trans_amt}</li>`);
    }

    if (matanahErr) {
        //show message set above
        $pledgePayBody.find('#ajaxMsgMatanahAmt').show();
        //set the timeout so it fades out.
        setTimeout(() => {
            $("#ajaxMsgMatanahAmt").fadeOut();
        }, 3000);
        //make sure it turns red
        $pledgePayBody.find('#matanah_message').removeClass("alert-success");
        $pledgePayBody.find('#matanah_message').addClass("alert-danger");
        workingAmount.css("border-color", "red");
        //do not process this value
        return false;
    }

    //now lets get the amounts
    amount = parseFloat(workingAmount.val());
    total_number = parseFloat($pledgePayBody.find('#total_amount').val());
    total_amt = total_number + amount;

    $.ajax({
        url: "/member-set-matanah_amount",
        type: "POST",
        data: {
            "pledge_id": pledge_id,
            "matanah_amount": amount,
            "_token": getCsrfToken()
        },
        success: function (response) {
            if (!response.success) {
                //error occurred, close the window and show the message
                $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html('<li><i class="fa-regular fa-circle-x"></i>&nbsp;' + response.error + '</li>');
                $pledgePayBody.find('#ajaxMsgMatanahAmt').show();

            } else {
                const normalizedAmount = parseFloat(amount) || 0;
                const formattedAmount = normalizedAmount.toFixed(2);

                if (window.pledgeObj && window.pledgeObj[pledge_id]) {
                    const pledge = window.pledgeObj[pledge_id];
                    pledge.matanah = 0;
                    pledge.amount = normalizedAmount;
                    pledge.balance_due = normalizedAmount;
                    pledge.format_amount = formattedAmount;
                    pledge.format_balance_due = formattedAmount;
                }

                if (Array.isArray(window.payBillModalSelectedPledges)) {
                    window.payBillModalSelectedPledges = window.payBillModalSelectedPledges.map((pledge) => {
                        if (Number(pledge.id) !== Number(pledge_id)) {
                            return pledge;
                        }
                        return {
                            ...pledge,
                            matanah: 0,
                            amount: normalizedAmount,
                            balance_due: normalizedAmount,
                            format_amount: formattedAmount,
                            format_balance_due: formattedAmount,
                        };
                    });
                }

                //set the matanah_counter so it can be used to change the message and check for multiple matanahs
                matanah_counter = $pledgePayBody.find('#matanah_ct').val();
                //subtract 1 off matanah_ct and if it reaches zero, we can enable submission button and set the grand total
                matanah_counter--;
                $pledgePayBody.find('#matanah_ct').val(matanah_counter);

                //it worked, set the message and display it.
                $pledgePayBody.find('#matanah_message').removeClass("alert-danger");
                $pledgePayBody.find('#matanah_message').addClass("alert-success");
                if (matanah_counter < 1) {
                    $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html(
                        '<li><i class="fa-regular fa-circle-x"></i>&nbsp;Matanah pledge amount set. You can now pay the pledge.</li>'
                    );
                } else {
                    $pledgePayBody.find('#ajaxMsgMatanahAmtUl').html(
                        '<li><i class="fa-regular fa-circle-x"></i>&nbsp;Matanah pledge amount set, but there are more amounts to set before you can make a payment.</li>'
                    );
                }

                $pledgePayBody.find('#ajaxMsgMatanahAmt').show();

                //we also need to update the table so that the input box (in the div) gets replaced by value
                //we need to set the correct line item to the amount. in case there are more than 1.
                $pledgePayBody.find('#matanah_input-' + pledge_id).html("$" + numberFormat(amount, 2));

                //enable the text box to enter amount to pay and enable it.  even though form, required not working, will manually check it.
                workingBox = $("input[id='amount_paid[" + pledge_id + "]']");
                workingBox.val(numberFormat(amount));
                workingBox.prop('disabled', false);
                //set the min to what they entered
                workingBox.attr('max', amount);
                if (matanah_counter < 1) {
                    $pledgePayBody.find('#matanah_input_tot').html("<strong>$" + numberFormat(total_amt, 2) + "</strong>");
                    $("#cover_surcharge").prop('disabled', false);

                    //get the total amount and display it on the total line
                    finish_amt = 0;
                    $pledgePayBody.find('input[name="amount_paid"]').map(function () {
                        //multiply by 1 to make it a number
                        finish_amt = finish_amt + (this.value * 1);
                    }).get();

                    $("#amt_due_total").html("$" + numberFormat(finish_amt));
                }
                runChangeAmount(workingBox.get(0));

                //set the total amount, so it will be used for the payment option
                $pledgePayBody.find('#total_amount').val(total_amt);
            }
            //set the timeout so it fades out.
            setTimeout(() => {
                $("#ajaxMsgMatanahAmt").fadeOut();
            }, 3000);
        },
        error: function () {
            //redirect to main page
            showErrMsg("A time out error occurred, please try again");
            openIndexPage();
        }
    });
}

function calculateRecurringPaymentAmount() {
    const round2 = n => Math.round(n * 100) / 100;
    const $parent = $('#pledge_pay_body');
    if (!$parent.length) return;

    const $freq = $parent.find('select[name="frequency"]');
    const frequency = $freq.val();
    const duration = parseInt($parent.find('#pledge_payment_duration').val(), 10) || 1;

    const totals = getSurchargePrincipalTotals($parent);
    const totalPrincipal =
        totals.total ?? parseFloat($parent.find('#total_amount').val()) ?? 0;

    if (!frequency || duration < 2 || !totalPrincipal) {
        $parent.find('#recurring-payment-display, #last-payment-note').hide();
        return;
    }

    const coverSurcharge = $parent.find('#cover_surcharge').is(':checked');

    const forceSurcharge = totals.forceTotal * window.surcharge_amt;
    const totalSurcharge =
        forceSurcharge + (coverSurcharge ? totals.optionalTotal * window.surcharge_amt : 0);

    const totalCombined = totalPrincipal + totalSurcharge;

    const principalPerInstallment = round2(totalPrincipal / duration);
    const surchargePerInstallment = round2(totalSurcharge / duration);
    const installmentTotal = principalPerInstallment + surchargePerInstallment;

    const lastPayment = round2(
        totalCombined - installmentTotal * (duration - 1)
    );

    $parent.find('input[name="installment_amount"]').val(principalPerInstallment);
    $parent.find('input[name="surcharge_installment_amount"]').val(surchargePerInstallment);

    $parent.find('#recurring-payment-text').text(
        `${$freq.find('option:selected').text().trim()} Payment: $${numberFormat(installmentTotal)}`
    );
    $parent.find('#recurring-payment-display').show();

    if (typeof syncLastPaymentNote === 'function') {
        syncLastPaymentNote($parent.find('#last-payment-note'), totalCombined, installmentTotal, duration);
    } else {
        $parent.find('#last-payment-note')
            .toggle(lastPayment !== installmentTotal)
            .text(`last payment will be $${numberFormat(lastPayment)}`);
    }
}

/**
 * Shared helper: show/hide "last payment will be $X" note.
 * Used by both recurring setup table and edit recurring modal.
 */
function syncLastPaymentNote($note, totalCombined, installmentTotal, duration) {
    if (!$note || !$note.length) {
        return;
    }
    const round2 = n => Math.round(n * 100) / 100;
    const total = round2(parseFloat(totalCombined) || 0);
    const per = round2(parseFloat(installmentTotal) || 0);
    const d = parseInt(duration || 0, 10) || 0;
    if (!total || !per || d < 2) {
        $note.hide().text('');
        return;
    }
    const last = round2(total - per * (d - 1));
    $note
        .toggle(last !== per)
        .text(`last payment will be $${numberFormat(last)}`);
}

function syncInstallmentLastPaymentNote($modal) {
    if (!$modal || !$modal.length) {
        return;
    }
    const pledgeAmount = getRecurringEditModalPledgeAmount($modal);
    const total = getRecurringBalanceDueTotalForInstallment($modal, pledgeAmount);
    const per = parseFloat(String($modal.find('#on_amount').val() || '').replace(/,/g, '')) || 0;
    const dur = parseInt($modal.find('#on_num_left').val() || 0, 10) || 0;
    syncLastPaymentNote($modal.find('#installment_last_payment_note'), total, per, dur);
}

function formatCurrency(amount) {
    const parsed = parseFloat(amount);
    if (Number.isNaN(parsed)) {
        return '0.00';
    }
    return parsed.toFixed(2);
}

/** @param {string[]} names @returns {string} */
function formatCampaignListOxford(names) {
    const list = (names || []).map((n) => String(n).trim()).filter(Boolean);
    if (!list.length) {
        return '';
    }
    if (list.length === 1) {
        return list[0];
    }
    if (list.length === 2) {
        return `${list[0]} and ${list[1]}`;
    }
    return `${list.slice(0, -1).join(', ')}, and ${list[list.length - 1]}`;
}

function formatSurchargePercent() {
    const percent = (parseFloat(window.surcharge_amt) || 0) * 100;
    if (!percent) return '0';
    const rounded = Math.round(percent * 100) / 100;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2);
}

function getSurchargePrincipalTotals($container) {
    const totals = {
        total: 0,
        forceTotal: 0,
        optionalTotal: 0
    };

    const $rows = $container.find('.sort_pledges tr');
    if (!$rows.length) {
        return totals;
    }

    $rows.each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $container)) {
            return;
        }
        const amount = parseFloat($row.data('amount-to-pay')) || 0;
        if (!amount) {
            return;
        }
        totals.total += amount;
        const forceFlag = String($row.data('force-surcharge')) === '1';
        if (forceFlag) {
            totals.forceTotal += amount;
        } else {
            totals.optionalTotal += amount;
        }
    });

    return totals;
}

function getForceSurchargeCampaigns($container, result = null) {
    if (result && Array.isArray(result.forceCampaignsArr) && result.forceCampaignsArr.length) {
        return [...new Set(result.forceCampaignsArr.filter(Boolean))];
    }

    const campaigns = [];
    $container.find('tbody tr').each(function () {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $container)) {
            return;
        }
        if (String($row.data('force-surcharge')) !== '1') {
            return;
        }
        const campaign = $row.data('campaign');
        if (campaign) {
            campaigns.push(campaign);
        }
    });

    return [...new Set(campaigns)];
}

function updateForceSurchargeRow($container, result = null) {
    const $coverRow = $container.find('#cover_surcharge_row');
    const $row = $container.find('#force_surcharge_row');
    if (!$row.length) {
        return;
    }

    const $requiredPanel = $container.find('#mgr_pledge_required_surcharge_panel');
    const campaigns = getForceSurchargeCampaigns($container, result);
    const $message = $container.find('#force_surcharge_message');
    const isMgrPledgeModal = $container.closest('#setPledgePaymentModal').length > 0;

    if (!campaigns.length) {
        $message.html('');
        $row.hide();
        if ($requiredPanel.length) {
            $requiredPanel.hide();
        }
        if ($coverRow.length) {
            $coverRow.data('mgrRequiredSurchargeActive', false);
        }
        pledgeUpdateSurchargeSectionRowVisibility($container);
        return;
    }

    const percent = formatSurchargePercent();
    const campaignText = isMgrPledgeModal ? formatCampaignListOxford(campaigns) : campaigns.join('/');
    $message.html(
        '<i class="fa-solid fa-triangle-exclamation fa-lg flex-shrink-0 mt-1 mgr-pledge-force-surcharge-icon" aria-hidden="true"></i>' +
            `<span class="ml-2 flex-grow-1">A ${percent}% processing fee will be added to ${campaignText} transactions</span>`
    );

    $row.show();
    if ($requiredPanel.length) {
        $requiredPanel.show();
    }
    if ($coverRow.length) {
        $coverRow.data('mgrRequiredSurchargeActive', true);
    }
    pledgeUpdateSurchargeSectionRowVisibility($container);
}

function resetSurchargeRows($container) {
    $container.find('#force_surcharge_message, #surcharge_message').html('');
    $container.find(
        '#force_surcharge_row, #mgr_pledge_required_surcharge_panel, #mgr_pledge_optional_surcharge_panel, #cover_surcharge_row'
    ).hide();
    $container.find('#cover_surcharge_row')
        .removeData('mgrOptionalSurchargePanelActive')
        .removeData('mgrRequiredSurchargeActive');
}

function getRecurringSchedulePledges() {
    return window.recurringScheduleData?.recurring_schedule?.pledges ?? [];
}

function getRecurringBalanceDueTotal() {
    return getRecurringSchedulePledges().reduce((total, pledge) => {
        const balance = parseFloat(pledge?.balance_due ?? 0);
        return total + (Number.isNaN(balance) ? 0 : balance);
    }, 0);
}

function recurringPledgeIdsMatch(leftId, rightId) {
    return leftId != null && rightId != null && String(leftId) === String(rightId);
}

function getRecurringEditModalPledgeAmount($modal) {
    const $pledgeAmount = $modal.find('#pledge_amount_input');
    if (!$pledgeAmount.length || $pledgeAmount.prop('disabled')) {
        return null;
    }
    const parsed = parseFloat(String($pledgeAmount.val() || '').replace(/,/g, ''));
    return Number.isNaN(parsed) ? null : parsed;
}

function getRecurringBalanceDueTotalForInstallment($modal, pledgeAmount = null) {
    const pledges = getRecurringSchedulePledges();
    const currentPledgeId = window.recurringScheduleData?.id ?? null;

    return pledges.reduce((total, pledge) => {
        const pledgeId = pledge.id ?? pledge.pledge_id ?? null;
        let balance;

        if (pledgeAmount != null && recurringPledgeIdsMatch(pledgeId, currentPledgeId)) {
            const amountPaid = parseFloat($modal.find('#pledge_amount_input').data('amountPaid')) || 0;
            balance = Math.max(0, pledgeAmount - amountPaid);
        } else {
            balance = parseFloat(pledge?.balance_due ?? 0);
        }
        return total + balance;
    }, 0);
}


function syncPledgeBalanceDueDisplay($modal) {
    const $amount = $modal.find('#pledge_amount_input');
    if (!$amount.length || $amount.prop('disabled')) {
        return;
    }
    const amountPaid = parseFloat($amount.data('amountPaid')) || 0;
    const amount = parseFloat(String($amount.val() || '').replace(/,/g, '')) || 0;
    $modal.find('#pledge_balance_due').text(formatCurrency(Math.max(0, amount - amountPaid)));
}

function getRecurringPledgeCount() {
    return getRecurringSchedulePledges().length;
}

function getInstallmentAmount($modal, numLeft, pledgeAmount = null) {
    const record = window.recurringScheduleData;
    if (!record) return 0;

    let installmentAmount = record?.recurring_schedule?.installment_amount
        ?? record?.installment_amount ?? record?.amount ?? 0;

    const remainingPayments = parseInt(numLeft ?? record?.num_left ?? 0, 10);
    if (!remainingPayments) return installmentAmount;

    const totalBalanceDue = getRecurringBalanceDueTotalForInstallment($modal, pledgeAmount);
    return parseFloat((totalBalanceDue / remainingPayments).toFixed(2));
}

function setPledgeTotals($modal) {
    const record = window.recurringScheduleData;
    const totalAmount = formatCurrency(record?.amount ?? 0);
    const balanceDue = formatCurrency(record?.balance_due ?? 0);
    const amountPaid = formatCurrency(record?.amount_paid ?? record?.ongoing_amount_paid ?? 0);
    const $amountInput = $modal.find('#pledge_amount_input');
    const $amountGroup = $modal.find('#pledge_amount_input_group');
    const $balanceLine = $modal.find('#pledge_balance_due_line');

    $amountInput.val(totalAmount);
    $amountInput.data('initial', $amountInput.val());
    $amountInput.data('amountPaid', parseFloat(amountPaid) || 0);
    $modal.find('#pledge_amount_paid').text(amountPaid);
    $modal.find('#pledge_balance_due').text(balanceDue);

    const isOngoingIndefinitely = !!record?.ongoing_indefinitely;
    $modal.find('#pledge_totals_row').toggleClass('d-none', !record);
    $amountGroup.toggleClass('d-none', isOngoingIndefinitely);
    $balanceLine.toggleClass('d-none', isOngoingIndefinitely);
    $amountInput.prop('disabled', isOngoingIndefinitely);
}

function validateRecurringInstallmentMinimum($modal) {
    if ($modal.find('#cancel_recur').prop('checked')) {
        return true;
    }

    const installmentAmount = parseFloat(String($modal.find('#on_amount').val() || '').replace(/,/g, '')) || 0;
    const minAmount = Number(window.min_trans_amt) || 0;
    const valid = installmentAmount >= minAmount;

    $modal.find('#enter_amt_err, #edit_enter_amt_err').toggle(!valid);

    return valid;
}

function validatePledgeAmountInput($modal) {
    if ($modal.data('ongoingType') === 'Donation') {
        return true;
    }
    const $amount = $modal.find('#pledge_amount_input');
    const $error = $modal.find('#pledge_amount_error');

    if (!$amount.length || $amount.prop('disabled')) {
        $error.addClass('d-none').text('');
        $amount.css('border-color', '');
        return true;
    }

    const amountPaid = parseFloat($amount.data('amountPaid')) || 0;
    const amount = parseFloat(($amount.val() || '').replace(/,/g, '')) || 0;

    const valid = amount >= amountPaid;

    $amount.css('border-color', valid ? '' : 'red');
    $error.text(valid ? '' : `Pledge amount cannot be less than the amount already paid.`)
        .toggleClass('d-none', valid);

    return valid;
}

function setInstallmentAmountNote($modal) {
    const pledges = getRecurringSchedulePledges();
    const selectedId = window.recurringScheduleData?.id ?? null;
    const pledgeAmount = getRecurringEditModalPledgeAmount($modal);

    const otherPledgesWithBalance = pledges.filter(({id, pledge_id, balance_due}) => {
        const pledgeId = id ?? pledge_id ?? null;
        if (!pledgeId || recurringPledgeIdsMatch(pledgeId, selectedId)) {
            return false;
        }
        return (Number(balance_due) || 0) > 0;
    });

    const $note = $modal.find('#installment_amount_note');

    if (!otherPledgesWithBalance.length) {
        $note.addClass('d-none').text('');
        return;
    }

    const totalBalanceDue = formatCurrency(getRecurringBalanceDueTotalForInstallment($modal, pledgeAmount));

    $note
        .text(`This amount reflects $${totalBalanceDue} total due on ${getRecurringPledgeCount()} pledges linked to this recurring schedule.`)
        .removeClass('d-none');
}

function updateOngoingDurationOption($modal) {
    const $durationSelect = $modal.find('#on_num_left');
    const $ongoingOption = $durationSelect.find('option[value="0"]');
    if ($ongoingOption.length === 0) {
        return;
    }
    const isOngoingIndefinitely = $modal.data('ongoingType') === 'Pledge'
        && window.recurringScheduleData?.ongoing_indefinitely;
    $durationSelect.prop('disabled', !!isOngoingIndefinitely);
    $durationSelect.closest('.row').toggle(!isOngoingIndefinitely);
    if ($modal.data('ongoingType') !== 'Pledge') {
        $ongoingOption.show();
        return;
    }
    const hasMultiplePledges = getRecurringPledgeCount() > 1;
    $ongoingOption.toggle(!hasMultiplePledges);
    if (hasMultiplePledges && parseInt($durationSelect.val(), 10) === 0) {
        const $firstVisibleDuration = $durationSelect.find('.duration-option:visible').first();
        if ($firstVisibleDuration.length) {
            $durationSelect.val($firstVisibleDuration.val()).change();
        }
    }
}

function updateRecurringInstallmentAmount($modal, pledge_type = 'Pledge') {
    if (!window.recurringScheduleData) {
        return;
    }
    if (pledge_type === 'Donation') {
        return;
    }
    const numLeft = $modal.find('#on_num_left').val();
    const pledgeAmount = getRecurringEditModalPledgeAmount($modal);
    const installmentAmount = getInstallmentAmount($modal, numLeft, pledgeAmount);
    $modal.find('#on_amount').val(formatCurrency(installmentAmount));
    setInstallmentAmountNote($modal);
    if (typeof syncInstallmentLastPaymentNote === 'function') {
        syncInstallmentLastPaymentNote($modal);
    }
}

function closeEditOngoingPledgeModal() {
    const $modal = $('#PledgeEditOngoingModal');

    $modal.modal('hide');

    $modal.find([
        '#on_amount',
        '#on_num_left',
        '#on_orig_duration',
        '#on_frequency_id',
        '#ongoing_id',
        '#on_custom_desc',
        '#ongoing_user_id',
        '#ongoing_user_name',
        '#ongoing_user_phone',
        '#ongoing_user_email'
    ].join(',')).val('');

    $modal.find('#pledge_amount_input').val('').css('border-color', '');
    $modal.find('#pledge_amount_error').addClass('d-none').text('');
    $modal.find('#pledge_totals_row').addClass('d-none');
    $modal.find('#installment_amount_note').addClass('d-none').text('');

    if (typeof setInstallmentAmountEditable === 'function') {
        setInstallmentAmountEditable($modal, true);
    }

    window.recurringScheduleData = null;
    $modal.removeData('ongoingType');
}

$(document).ready(function () {
    $(document).on('change', '#PledgeEditOngoingModal #on_num_left', function () {
        const $modal = $('#PledgeEditOngoingModal');
        updateRecurringInstallmentAmount($modal, $modal.data('ongoingType'));
    });

    $(document).on('input change', '#PledgeEditOngoingModal #pledge_amount_input', function () {
        const $modal = $(this).closest('.modal');
        syncPledgeBalanceDueDisplay($modal);
        if (!validatePledgeAmountInput($modal)) {
            return;
        }
        updateRecurringInstallmentAmount($modal);
    });

    $(document).on('input change', '#PledgeEditOngoingModal #on_amount', function () {
        const $modal = $(this).closest('.modal');
        if (typeof syncInstallmentLastPaymentNote === 'function') {
            syncInstallmentLastPaymentNote($modal);
        }
    });

    $(document).on('change', '#full_payment', function () {
        const $container = $(this).closest('#pledge_pay_body, .modal-content, .modal');
        updateStatementPledgeSelectionValidation($container);
    });

    $(document).on('change', 'input.statement-pledge-select', function () {
        const $container = $(this).closest('#pledge_pay_body, .modal-content, .modal');
        updateStatementPledgeSelectionValidation($container);
        const $payRoot = pledgePayUiRoot($container);
        if ($payRoot.length && $payRoot.find('#mgr_open_payment_apply_amount').length) {
            mgrPledgeModalRecalcOpenApplyCap($payRoot);
        }
        if (typeof pledgePayBillUpdateSummary === 'function') {
            pledgePayBillUpdateSummary($payRoot.length ? $payRoot : $container);
        }
    });

    $(document).on('hidden.bs.modal', '#setPledgePaymentModal', function (e) {
        if (e.target !== this) {
            return;
        }
        resetPledgePaymentModalState($(this));
        resetSurchargeRows($(this));
    });

    $(document).on('shown.bs.modal', '#setPledgePaymentModal', function () {
        const $m = $(this);
        if ($m.find('#mgr_pledge_bill_card_fields_wrap').length && typeof window.setDafCardType === 'function') {
            window.setDafCardType('mgr_pledge_bill_', 'credit');
        }
        if (typeof window.mgrPledgeBillInitExpiryInputMask === 'function') {
            window.mgrPledgeBillInitExpiryInputMask($m);
        }
        if (typeof pledgePayBillUpdateSummary === 'function') {
            pledgePayBillUpdateSummary($m);
        }
    });

    $(document).on('input', '#setPledgePaymentModal #mgr_pledge_bill_card, #pledge_pay_body[data-mgr-style-pay-ui="1"] #mgr_pledge_bill_card', function () {
        const $inp = $(this);
        let v = $inp.val();
        const last = v.slice(-1);
        if (last && isNaN(last)) {
            $inp.val(v.slice(0, -1));
            return;
        }
        const amexTest = v.replace(/\s/g, '');
        if (amexTest.match(/^3[47]\d{2}/)) {
            $inp.val(amexTest.replace(/(\d{4})\s*(\d{6})?\s*(\d{5})?/, '$1 $2 $3').replace(/\s\s/g, ' ').trim().substring(0, 17));
        } else {
            $inp.val(amexTest.replace(/(\d{4})(?=\d)/g, '$1 '));
        }
    });
});

function initPledgePayDatatable($parentDiv) {
    if ($.fn.DataTable) {
        window.payTableTable = $parentDiv.find('table').DataTable({
            rowReorder: {
                selector: 'td:nth-child(1)'
            },
            columnDefs: [
                {
                    "targets": 0,
                    'orderable': false,
                    "className": 'dt-center reorder',
                    "width": "10%"
                },
                {
                    "targets": 1,
                    'orderable': true,
                    "className": "dt-left",
                    "width": "25%"
                },
                {
                    "targets": 2,
                    'orderable': true,
                    "className": "dt-left",
                    "width": "25%"
                },
                {
                    "targets": 3,
                    'orderable': true,
                    "className": "dt-left",
                    "width": "15%"
                },
                {
                    "targets": 4,
                    'orderable': true,
                    "className": "dt-left",
                    "width": "15%"
                }
            ],
            paging: false,
            info: false,
            searching: false,
        });

        window.payTableTable.on('row-reordered', function () {
            // Update the order numbers in the first column after reordering
            $('#set_payment_table tbody tr').each(function (index) {
                $(this).find('td:first').text(index + 1);
            });
        });
    }
}

const PLEDGE_PAYMENT_AMOUNT_INPUT_SELECTOR = [
    'input[name="amount_paid"]',
    'input[name="matanah_amount"]',
    '.amount_value',
    '.matanah_amt_entry',
    '.mgr-gateway-credit-apply',
    '#mgr_open_payment_apply_amount',
    '#open_payment_apply_amount',
    '.open-payment-alloc-input',
].join(', ');

function touchKioskInactivityTimer() {
    window.user_active = true;
    window.last_activity = Date.now();
}

function normalizePledgePaymentAmountInputs($root) {
    if (!$root || !$root.length) {
        return;
    }
    $root.find(PLEDGE_PAYMENT_AMOUNT_INPUT_SELECTOR).each(function () {
        const el = this;
        if (el.type === 'number') {
            el.type = 'text';
        }
        el.removeAttribute('step');
        el.removeAttribute('min');
        if (!el.getAttribute('inputmode')) {
            el.setAttribute('inputmode', 'decimal');
        }
        el.classList.add('currency-amount-input');
    });
}

function renderPledgePaymentTable(pledges, isRecurringMode = false, $pledgePayRoot = null) {
    let percent = (window.surcharge_amt * 100) + '%';
    let $tableDiv;
    let $container;

    if ($pledgePayRoot && $pledgePayRoot.length) {
        $container = $pledgePayRoot.first();
        $tableDiv = $container.find('#set_pledge_payment_table').first();
    } else {
        $tableDiv = $('#pledge_pay_body #set_pledge_payment_table').first();
        if (!$tableDiv.length) {
            $tableDiv = $('#setPledgePaymentModal #pledge_pay_body #set_pledge_payment_table').first();
        }
        if (!$tableDiv.length) {
            $tableDiv = $('#setPledgePaymentModal #set_pledge_payment_table').first();
        }
        if (!$tableDiv.length) {
            $tableDiv = $('#set_pledge_payment_table').first();
        }
        $container = $tableDiv.closest('#pledge_pay_body');
        if (!$container.length) {
            $container = $tableDiv.closest('.modal-content');
        }
        if (!$container.length) {
            $container = $tableDiv;
        }
    }

    const paymentMode = getPaymentMode($container);
    const isStatement = isStatementEmailPayment($container);
    const payType = $container.find('#payment_type').val() || 'pay';
    const showSelectColumn = isStatement
        && pledges.length > 1
        && paymentMode !== 'recurring'
        && !isRecurringMode
        && payType !== 'mark';

    // "Manager style" pay UI renders both in modal and on statement payment page shell.
    // Detect via shared-ui data attribute instead of only modal DOM.
    const isMgrStylePayUi =
        $container.is('[data-mgr-style-pay-ui="1"]')
        || $container.closest('[data-mgr-style-pay-ui="1"]').length > 0
        || $container.closest('#setPledgePaymentModal').length > 0;

    // Recurring requires single draggable table (#set_payment_table).
    // Full/partial uses grouped-by-gateway tables.
    let result = isRecurringMode
        ? buildRecurringSinglePaymentTable(pledges, false)
        : buildManagerGroupedPaymentTable(pledges, false, showSelectColumn, false);

    if (result.tableNode) {
        $tableDiv.empty().append(result.tableNode);
    } else {
        $tableDiv.html(result.tableHtml);
    }

    normalizePledgePaymentAmountInputs($container);

    // Recurring ordering uses jQuery UI sortable (see initializeRecurringTable()).
    let isMarkPaid = $container.find('#payment_type').val() === 'mark';
    $container.find('#cover_surcharge_row')
        .hide()
        .data('mgrOptionalSurchargePanelActive', false)
        .data('mgrRequiredSurchargeActive', false);
    $container.find('#mgr_pledge_optional_surcharge_panel').hide();
    $container.find('#mgr_pledge_required_surcharge_panel').hide();
    $container.find('#force_surcharge_row').hide();
    $container.find('#cover_surcharge').prop('checked', false);
    $container.find('#surcharge_message').html('');
    if (isMarkPaid) {
        $container.find('.mark_paid_div').show();
    }

    const $optionalSurchargePanel = $container.find('#mgr_pledge_optional_surcharge_panel');
    const surchargeRate = parseFloat(window.surcharge_amt);
    if (Number.isFinite(surchargeRate) && surchargeRate > 0 && result.optionSurchargeFound && !isMarkPaid) {
        let cleaned = [...new Set(result.optionCampaignsArr)];
        if (isMgrStylePayUi) {
            const pctLabel = typeof formatSurchargePercent === 'function' ? formatSurchargePercent() : String((window.surcharge_amt * 100));
            const campPhrase = cleaned.length === 1
                ? `${cleaned[0]} campaign`
                : `${formatCampaignListOxford(cleaned)} campaigns`;
            $container.find('#surcharge_message').html(
                `Cover the ${pctLabel}% processing fee for the ${campPhrase}.`
            );
        } else {
            $container.find('#surcharge_message').html(
                'I would like to cover the cost of processing for the ' +
                cleaned.join("/") + ' campaign(s) by adding ' + percent
            );
        }
        if ($optionalSurchargePanel.length) {
            $optionalSurchargePanel.show();
        }
        $container.find('#cover_surcharge_row').show().data('mgrOptionalSurchargePanelActive', true);
    }
    pledgeUpdateSurchargeSectionRowVisibility($container);

    if (isMarkPaid) {
        $container.find('#force_surcharge_message').html('');
        $container.find('#force_surcharge_row').hide();
    } else {
        updateForceSurchargeRow($container, result);
    }
    $container.find('#matanah_ct').val(result.matanahCount);

    if (window.kiosk_validated) {
        $tableDiv.find(".matanah_amt_entry, .amount_value, input[name='amount_paid']").keyboard({
            rtl: true,
            layout: 'custom',
            customLayout: {'normal': ['1 2 3', '4 5 6', '7 8 9', '{b} 0 .', '{accept}']},
            usePreview: false,
            restrictInput: true,
            preventPaste: true,
            autoAccept: true,
            tabNavigation: true,
            initialFocus: false,
            visible: touchKioskInactivityTimer,
            change: touchKioskInactivityTimer,
            beforeClose: function (e, keyboard) {
                touchKioskInactivityTimer();
                if (typeof window.persistVirtualKeyboardValue === 'function') {
                    return window.persistVirtualKeyboardValue(e, keyboard);
                }
                return true;
            },
        });

        const $ccFields = $container.find(
            "#mgr_pledge_bill_name, #mgr_pledge_bill_card, #mgr_pledge_bill_expiry_month, " +
            "#mgr_pledge_bill_expiry_year, #mgr_pledge_bill_cvv2, #mgr_pledge_bill_avs_zip"
        );
        $ccFields.not('.ui-keyboard-input').keyboard({
            layout: 'custom',
            customLayout: {
                'normal': ['1 2 3 4 5 6 7 8 9 0', 'q w e r t y u i o p', 'a s d f g h j k l',
                    '{shift} z x c v b n m {b}', '{accept} {space} {cancel}'],
                'shift': ['1 2 3 4 5 6 7 8 9 0', 'Q W E R T Y U I O P', 'A S D F G H J K L',
                    '{shift} Z X C V B N M {b}', '{accept} {space} {cancel}'],
            },
            usePreview: false,
            restrictInput: true,
            preventPaste: true,
            autoAccept: true,
            tabNavigation: true,
            initialFocus: false,
            visible: touchKioskInactivityTimer,
            change: touchKioskInactivityTimer,
            beforeClose: function (e, keyboard) {
                touchKioskInactivityTimer();
                if (typeof window.persistVirtualKeyboardValue === 'function') {
                    return window.persistVirtualKeyboardValue(e, keyboard);
                }
                return true;
            },
        });
    }

    updateStatementPledgeSelectionValidation($container);

    // Manager-style summary syncing: keeps right-side totals + saved cards + open credits in sync
    // with current table state. This is now the only supported summary flow.
    if (isMgrStylePayUi && typeof pledgePayBillUpdateSummary === 'function') {
        const $summaryRoot = $container.closest('#pledge_pay_body').length
            ? $container.closest('#pledge_pay_body')
            : $container.closest('#setPledgePaymentModal');
        const paymentModeIsRecurring =
            $summaryRoot.find('input[name="payment_mode"]:checked').val() === 'recurring';
        mgrPledgeModalSyncSummaryVisibility($summaryRoot);
        pledgePayBillSyncSummaryColumnLayout($summaryRoot, paymentModeIsRecurring);
        pledgePayBillUpdateSummary($summaryRoot);
        mgrPledgeModalSyncPaymentTableFooter($summaryRoot);
        updatePledgePayNowButtonEnabledState($summaryRoot);
    }

    pledgeUpdateSurchargeSectionRowVisibility($container);

    return result;
}

function buildRecurringSinglePaymentTable(pledges, isManagerView) {
    let total_pledge_amt = 0;
    let matanah_found = false;
    let matanah_count = 0;
    let force_surcharge_found = false;
    let force_campaigns_arr = [];
    let option_surcharge_found = false;
    let option_campaigns_arr = [];

    const parsePledgeDate = (pledge) => {
        const rawDate = pledge.pledge_date ?? pledge.date_pledged;
        if (!rawDate) return null;
        const parsed = new Date(rawDate);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const sortedPledges = [...pledges].sort((a, b) =>
        (parsePledgeDate(a) ?? 0) - (parsePledgeDate(b) ?? 0) ||
        (Number(a.id) || 0) - (Number(b.id) || 0)
    );

    const showOrderColumn = sortedPledges.length > 1;

    let tableHtml = `<table class='table w-100 table-sm display ${showOrderColumn ? "table-draggable" : ""}' id="set_payment_table">
        <thead>
            <tr>
                ${showOrderColumn ? `<th><strong>Order</strong>&nbsp;<i class='fa-regular fa-circle-info fa-lg' data-toggle='tooltip' data-placement='top' title='Order in which pledges will be paid'></i></th>` : ""}
                <th><strong>Campaign</strong></th>
                <th><strong>Description</strong></th>
                <th><strong>Date Pledged</strong></th>
                ${isManagerView ? "<th><strong>Amount Pledged</strong></th>" : ""}
                <th><strong>Amount Due</strong></th>
            </tr>
        </thead>
        <tbody class="sort_pledges">`;

    for (let i = 0; i < sortedPledges.length; i++) {
        const pledge = sortedPledges[i];
        const use_amount = Number(pledge.balance_due || pledge.format_balance_due || pledge.format_amount || pledge.amount);
        const forceSurchargeFlag = pledge.force_surcharge ? 1 : 0;
        if (pledge.force_surcharge) {
            force_surcharge_found = true;
            force_campaigns_arr.push(pledge.campaign);
        } else {
            option_surcharge_found = true;
            option_campaigns_arr.push(pledge.campaign);
        }

        const gatewayIdAttr = Number(pledge.gateway_id) > 0 ? ` data-gateway-id="${escHtml(pledge.gateway_id)}"` : '';

        if (pledge.matanah === 0 || use_amount > 0) {
            tableHtml += `<tr data-pledge-id="${pledge.id}"${gatewayIdAttr} data-amount-to-pay="${use_amount}" data-balance-due="${use_amount}" data-force-surcharge="${forceSurchargeFlag}" data-campaign="${pledge.campaign}">
                ${showOrderColumn ? `<td>${i + 1}</td>` : ""}
                <td>${pledge.campaign}</td>
                <td>${pledge.description ?? ""}</td>
                <td>${pledge.date_pledged || pledge.pledge_date}</td>
                ${isManagerView ? `<td>$${pledge.format_amount || pledge.amount}</td>` : ""}
                <td>$${use_amount}</td>
            </tr>`;
            total_pledge_amt += use_amount;
        } else {
            // In recurring view, matanah pledges cannot be scheduled; keep row but mark as matanah.
            matanah_found = true;
            matanah_count++;
            tableHtml += `<tr data-pledge-id="${pledge.id}"${gatewayIdAttr} data-amount-to-pay="${pledge.amount}" data-balance-due="${use_amount}" data-force-surcharge="${forceSurchargeFlag}" data-campaign="${pledge.campaign}">
                ${showOrderColumn ? `<td>${i + 1}</td>` : ""}
                <td>${pledge.campaign}</td>
                <td>${pledge.description ?? ""}</td>
                <td>${pledge.date_pledged || pledge.pledge_date}</td>
                ${isManagerView ? `<td>$${pledge.format_amount || pledge.amount}</td>` : ""}
                <td>Matanah</td>
            </tr>`;
        }
    }
    tableHtml += `</tbody>`;

    let total_line = "";
    if (sortedPledges.length > 1) {
        const col = (isManagerView ? 4 : 3) + (showOrderColumn ? 1 : 0);
        const amtId = isManagerView ? 'amt_due_total_payment' : 'amt_due_total';
        total_line = `<tfoot><tr><td colspan='${col}'><strong>Totals</strong></td>`;
        if (matanah_found) {
            total_line += `<td id='matanah_input_tot'><strong>Matanah</strong></td></tr>`;
        } else {
            const show = convert_to_show_dollar(total_pledge_amt);
            total_line += `<td id='matanah_input_tot'><strong>${show}</strong></td></tr>`;
        }
        total_line += `</tfoot>`;
    }

    tableHtml += `${total_line}</table>`;

    return {
        tableHtml,
        totalAmount: total_pledge_amt,
        matanahCount: matanah_count,
        matanahFound: matanah_found,
        forceSurchargeFound: force_surcharge_found,
        forceCampaignsArr: force_campaigns_arr,
        optionSurchargeFound: option_surcharge_found,
        optionCampaignsArr: option_campaigns_arr,
        showOrderColumn: showOrderColumn
    };
}

function buildManagerGroupedPaymentTable(pledges, isManagerView, showSelectColumn) {
    let total_pledge_amt = 0;
    let matanah_found = false;
    let matanah_count = 0;
    let force_surcharge_found = false;
    let force_campaigns_arr = [];
    let option_surcharge_found = false;
    let option_campaigns_arr = [];

    const amountInputHtml = ({id, value, max, min = 0, disabled = false, isManager = false}) => {
        const val = isManager ? Number(value).toFixed(2) : numberFormat(Number(value) || 0, 2);
        return `<input type="text"
            inputmode="decimal"
            class="form-control-sm amount_value currency-amount-input"
            id="amount_paid[${escHtml(id)}]"
            name="amount_paid"
            value="${escHtml(val)}"
            max="${escHtml(String(max))}"
            ${min ? `min="${escHtml(String(min))}"` : ""}
            ${disabled ? "disabled" : ""}>`;
    };

    const matanahInputHtml = (pledgeId) => {
        const pidRaw = String(pledgeId);
        const pid = escHtml(pidRaw);
        const minAmt = escHtml(window.min_trans_amt);
        return `<div class="input-group" id="matanah_input-${pid}" style="flex-wrap: nowrap;">
            <input type="text"
                class="form-control-sm no_right_rounding brown_border matanah_amt_entry currency-amount-input"
                name="matanah_amount"
                id="matanah_amount[${pid}]"
                inputmode="decimal"
                placeholder="$99.99"
                min="${minAmt}"
                oninput="this.setCustomValidity('')"
                oninvalid="this.setCustomValidity('Please Enter Amount in the following format: 9999.99, the minimum you can enter is $${minAmt}')">
            <div class="input-group-append">
                <button type="button"
                    class="form-control-sm brown_border no_left_rounding brown_background"
                    onclick="saveMatanahAmount('${pid}')">Save</button>
            </div>
        </div>`;
    };

    const parsePledgeDate = (pledge) => {
        const rawDate = pledge.pledge_date ?? pledge.date_pledged;
        if (!rawDate) {
            return null;
        }
        const parsed = new Date(rawDate);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const sortedPledges = [...pledges].sort((a, b) =>
        (parsePledgeDate(a) ?? 0) - (parsePledgeDate(b) ?? 0) ||
        (Number(a.id) || 0) - (Number(b.id) || 0)
    );

    const groupMap = new Map();
    sortedPledges.forEach((pledge) => {
        const gid = Number(pledge.gateway_id) || 0;
        if (!groupMap.has(gid)) {
            groupMap.set(gid, []);
        }
        groupMap.get(gid).push(pledge);
    });

    const groupIds = [...groupMap.keys()].sort((a, b) => {
        const minA = Math.min(...groupMap.get(a).map((p) => parsePledgeDate(p)?.getTime() ?? 0));
        const minB = Math.min(...groupMap.get(b).map((p) => parsePledgeDate(p)?.getTime() ?? 0));
        return minA - minB || a - b;
    });

    const congregationGatewayCountRaw = window.congregationGatewayCount;
    const congregationGatewayCount = (congregationGatewayCountRaw === undefined || congregationGatewayCountRaw === null)
        ? NaN
        : Number(congregationGatewayCountRaw);
    const omitGatewaySectionHeaders = Number.isFinite(congregationGatewayCount) && congregationGatewayCount === 1;

    let tableHtml = `<div class="mgr-pledge-gateway-stack">`;
    groupIds.forEach((gid) => {
        const groupPledges = groupMap.get(gid);
        const first = groupPledges[0];
        const label = (String(first.gateway_title || '').trim()) || 'Credit';
        const icon = first.gateway_icon_class || 'fa-light fa-sack-dollar';

        tableHtml += `<section class="mgr-pledge-gateway-group" data-gateway-id="${escHtml(gid)}">`;
        if (!omitGatewaySectionHeaders) {
            tableHtml += `<header class="mgr-pledge-gateway-header d-flex align-items-center">
                <div class="mgr-pledge-gateway-icon mr-2">
                    <i class="${escHtml(icon)} fa-lg brown_color" aria-hidden="true"></i>
                </div>
                <div class="mgr-pledge-gateway-title font-weight-bold">${escHtml(label)} Account</div>
            </header>`;
        }

        tableHtml += `<div class="mgr-pledge-gateway-body">
            <table class="table w-100 table-sm display mgr-pledge-gateway-payment-table mb-0" data-gateway-id="${escHtml(gid)}">
                <thead>
                    <tr>
                        ${showSelectColumn ? `<th><strong>Select</strong></th>` : ""}
                        <th><strong>Campaign</strong></th>
                        <th><strong>Description</strong></th>
                        <th><strong>Date Pledged</strong></th>
                        ${isManagerView ? `<th><strong>Amount Pledged</strong></th>` : ""}
                        <th><strong>Amount Due</strong></th>
                        <th><strong>Amount to Pay</strong></th>
                    </tr>
                </thead>
                <tbody class="sort_pledges">`;

        for (let i = 0; i < groupPledges.length; i++) {
            const pledge = groupPledges[i];
            const use_amount = Number(pledge.balance_due || pledge.format_balance_due || pledge.format_amount || pledge.amount);
            const forceSurchargeFlag = pledge.force_surcharge ? 1 : 0;
            if (pledge.force_surcharge) {
                force_surcharge_found = true;
                force_campaigns_arr.push(pledge.campaign);
            } else {
                option_surcharge_found = true;
                option_campaigns_arr.push(pledge.campaign);
            }

            const amountToPay = pledge.matanah === 0 || use_amount > 0 ? use_amount : pledge.amount;

            tableHtml += `<tr
                data-pledge-id="${escHtml(pledge.id)}"
                data-gateway-id="${escHtml(gid)}"
                data-amount-to-pay="${escHtml(amountToPay)}"
                data-balance-due="${escHtml(use_amount)}"
                data-force-surcharge="${escHtml(forceSurchargeFlag)}"
                data-campaign="${escHtml(pledge.campaign)}">`;

            if (showSelectColumn) {
                tableHtml += `<td><input type="checkbox" class="statement-pledge-select" checked></td>`;
            }

            tableHtml += `<td>${escHtml(pledge.campaign || '')}</td>
                <td>${escHtml(pledge.description ?? '')}</td>
                <td>${escHtml(pledge.date_pledged || pledge.pledge_date || '')}</td>
                ${isManagerView ? `<td>$${escHtml(pledge.format_amount || pledge.amount)}</td>` : ""}`;

            if (pledge.matanah === 0 || use_amount > 0) {
                tableHtml += `<td>$${escHtml(use_amount)}</td>
                    <td>${amountInputHtml({
                        id: pledge.id,
                        value: use_amount,
                        max: use_amount,
                        isManager: isManagerView
                    })}</td>`;
                total_pledge_amt += use_amount;
            } else {
                matanah_found = true;
                matanah_count += 1;
                tableHtml += `<td>${matanahInputHtml(pledge.id)}</td>
                    <td>${amountInputHtml({
                        id: pledge.id,
                        value: 0,
                        max: use_amount,
                        min: window.min_trans_amt,
                        disabled: true,
                        isManager: isManagerView
                    })}</td>`;
            }

            tableHtml += `</tr>`;
        }

        tableHtml += `</tbody></table>`;

        if (gid > 0) {
            tableHtml += `<div class="mgr-gateway-credit-panel mgr-gateway-credit-inactive mgr-gateway-no-credit" data-gateway-id="${escHtml(gid)}">
                <div class="mgr-gateway-credit-row align-items-center justify-content-between" style="display: none;">
                    <div class="form-check mb-0 mr-3">
                        <input type="checkbox" class="form-check-input mgr-gateway-use-credit" id="mgr_gateway_use_credit_${escHtml(gid)}" data-gateway-id="${escHtml(gid)}">
                        <label class="form-check-label label_font mb-0" for="mgr_gateway_use_credit_${escHtml(gid)}">Apply credit balance</label>
                    </div>
                    <div class="mgr-gateway-credit-amount-wrap m-0 p-0">
                        <div class="mgr-gateway-credit-input">
                            <label class="label_font small d-block mb-1" style="white-space: nowrap; align-content: center; margin-right: 5px;">Apply: </label>
                            <div class="input-group mgr-pledge-currency-input mb-0">
                                <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                                <input type="text" inputmode="decimal" class="form-control mgr-gateway-credit-apply currency-amount-input" data-gateway-id="${escHtml(gid)}" value="" placeholder="0.00" disabled>
                            </div>
                        </div>
                    </div>
                    <div class="mgr-gateway-credit-available-line text-muted small mr-3">$<span class="mgr-gateway-credit-available" data-gateway-id="${escHtml(gid)}">0.00</span> available</div>
                </div>
                <div class="mgr-gateway-no-credit-note text-muted small" style="display: block;">No open credit funds available.</div>
            </div>`;
        } else {
            tableHtml += `<div class="text-muted small px-2 py-2 border-top">Credit by gateway is not available for pledges without a campaign gateway.</div>`;
        }

        tableHtml += `</div></section>`;
    });

    tableHtml += `</div>`;

    return {
        tableHtml,
        totalAmount: total_pledge_amt,
        matanahCount: matanah_count,
        matanahFound: matanah_found,
        forceSurchargeFound: force_surcharge_found,
        forceCampaignsArr: force_campaigns_arr,
        optionSurchargeFound: option_surcharge_found,
        optionCampaignsArr: option_campaigns_arr,
        showOrderColumn: false
    };
}

function resetPledgePaymentModalState($modal) {
    const $m = $modal && $modal.length ? $modal : $('#setPledgePaymentModal');
    if (!$m.length) {
        return;
    }

    const $body = $m.find('#pledge_pay_body').length ? $m.find('#pledge_pay_body') : $m;

    if (typeof destroyRecurringTable === 'function') {
        destroyRecurringTable($m);
    }

    $m.find('#full_payment').prop('checked', true);
    $m.find('#recurring_payment').prop('checked', false);
    $m.find('label[for="full_payment"]').addClass('active');
    $m.find('label[for="recurring_payment"]').removeClass('active');

    $m.find('.recurring-setup').hide()
        .find('input:not([type="checkbox"]), select, textarea')
        .prop('required', false);
    $m.find('#recurring-payment-display, #last-payment-note').hide();
    $m.find('#run_today').prop('checked', true);
    $m.find('input[name="installment_amount"], input[name="surcharge_installment_amount"]').val('');
    $m.find('input[name="pledge_start_date"]').val('');

    const $home = $body.find('#mgr_recurring_fields_home');
    const $slot = $body.find('#mgr_recurring_fields_slot');
    if ($home.length && $slot.length && $slot.children().length) {
        $home.append($slot.children());
        $slot.hide().empty();
    }

    $m.find('#ajaxMsgMatanahAmt, #mgr_pledge_bill_cc_ajax_err').hide();
    $m.find('#ajaxMsgMatanahAmtUl, #mgr_pledge_bill_cc_ajax_err_ul').empty();
    $m.find('#mgr_pledge_bill_name,#mgr_pledge_bill_card,#mgr_pledge_bill_expiry_month,#mgr_pledge_bill_expiry_year,#mgr_pledge_bill_cvv2,#mgr_pledge_bill_avs_zip').val('');
    $m.find('#mgr_pledge_bill_save_card,#mgr_pledge_bill_use_otp').prop('checked', false);

    window.recurringScheduleData = null;
    window.payBillModalSelectedPledges = null;
    window.openBalanceAvailable = 0;
    window.mgrPledgeBillDafCardType = 'credit';

    const $payBtn = $m.find('#pay_now_button');
    if ($payBtn.length && typeof setPledgePayNowButtonLabel === 'function') {
        setPledgePayNowButtonLabel($payBtn, 'Make Payment');
    }
}

function openPayBillModal(pledge = null, payType) {
    const $modal = $('#setPledgePaymentModal');
    resetPledgePaymentModalState($modal);

    const selectedPledges = pledge
        ? [pledge]
        : $('input:checkbox[name="action_check[]"]:checked')
            .map(function () {
                return $(this).data('pledge');
            })
            .get();

    $modal.find('#payment_type').val(payType);

    const $payFlowRows = $modal.find('.row.payment_type, .row.recurring-setup, #cover_surcharge_row');
    const $payFlowRowsVisible = $modal.find('.row.payment_type, #cover_surcharge_row');
    const $conditionalFields = $payFlowRows.find('input:not([type="checkbox"]), select, textarea');

    function toggleConditionalRequired(isRequired) {
        $conditionalFields.each(function () {
            const $field = $(this);

            if ($field.data('original-required') === undefined) {
                $field.data('original-required', $field.prop('required'));
            }

            $field.prop(
                'required',
                isRequired ? $field.data('original-required') === true : false
            );
        });
    }

    if (payType === 'mark') {
        setPledgePayNowButtonLabel($modal.find('#pay_now_button'), 'Apply Payment');

        $modal.find('#modal_header').html(
            selectedPledges.length > 1
                ? 'Mark Pledges as Paid'
                : 'Mark Pledge as Paid'
        );

        $modal.find('#mark_paid_notes_div, .mark_paid_div, .payment_table_row').show();
        $modal.find('#surcharge_row').hide();

        $payFlowRows.hide();
        toggleConditionalRequired(false);

        $modal.find('#mgr_pledge_summary_section, #mgr_pledge_fully_covered_row').hide();
        if ($modal.find('#mgr_use_open_payment_balance').length) {
            $modal.find('#mgr_use_open_payment_balance').prop('checked', false);
        }
        if ($modal.find('#mgr_open_payment_apply_amount').length) {
            $modal.find('#mgr_open_payment_apply_amount').val('');
        }
        $modal.find('.mgr-gateway-use-credit').prop('checked', false);
        $modal.find('.mgr-gateway-credit-apply').val('').prop('disabled', true);
        $modal.find('.mgr-gateway-credit-panel').addClass('mgr-gateway-credit-inactive');
    } else {
        $modal.find('#modal_header').html('Setup Pledge Payment');

        $payFlowRowsVisible.show();
        toggleConditionalRequired(true);

        if ($modal.find('#full_payment').is(':checked')) {
            if (typeof destroyRecurringTable === 'function') {
                destroyRecurringTable($modal);
            }

            $modal.find('.recurring-setup')
                .hide()
                .find('input, select, textarea')
                .prop('required', false);

            $modal.find('#recurring-payment-display').hide();
        } else {
            $modal.find('.recurring-setup')
                .show()
                .find('input:not([type="checkbox"]), select, textarea')
                .prop('required', true);
        }

        $modal.find('#mgr_pledge_summary_section, #mgr_pledge_fully_covered_row').hide();
        if ($modal.find('#mgr_use_open_payment_balance').length) {
            $modal.find('#mgr_use_open_payment_balance').prop('checked', false);
        }
        if ($modal.find('#mgr_open_payment_apply_amount').length) {
            $modal.find('#mgr_open_payment_apply_amount').val('');
        }
        $modal.find('.mgr-gateway-use-credit').prop('checked', false);
        $modal.find('.mgr-gateway-credit-apply').val('').prop('disabled', true);
        $modal.find('.mgr-gateway-credit-panel').addClass('mgr-gateway-credit-inactive');
    }

    const formattedPledges = selectedPledges.map((p) => {
        const pid = p.id ?? p.pledge_id;
        const amt = Number(p.amount ?? 0);
        const bal = Number(p.balance_due ?? 0);
        const rawDate = p.pledge_date ?? p.date_pledged ?? null;
        return {
            id: pid,
            user_name: p.user_name,
            user_id: p.user_id,
            user_email: p.user_email ?? p.email ?? null,
            campaign: p.campaign,
            description: p.description ?? '',
            date_pledged: formatPledgeDateUsDisplay(rawDate),
            pledge_date: formatPledgeDateUsDisplay(rawDate),
            amount: amt.toFixed(2),
            balance_due: p.balance_due ?? bal,
            format_balance_due: bal.toFixed(2),
            format_amount: amt.toFixed(2),
            matanah: p.matanah,
            force_surcharge: p.force_surcharge,
            gateway_id: p.gateway_id ?? p.gatewayId ?? null,
            gateway_title: p.gateway_title ?? null,
            gateway_icon_class: p.gateway_icon_class ?? null,
        };
    });

    window.payBillModalSelectedPledges = formattedPledges;

    updateMultiGatewayPaymentModeWarning($modal, formattedPledges, payType);

    const result = renderPledgePaymentTable(formattedPledges, false, $modal.find('#pledge_pay_body'));

    const first = selectedPledges[0] ?? {};

    $modal.find('#payment_email').val(first.user_email ?? first.email ?? null);
    $modal.find('#payment_user_name').val(first.user_name ?? null);
    $modal.find('#payment_member_name').text(first.user_name ?? null);
    $modal.find('#payment_user_id').val(first.user_id ?? '');
    $modal.find('#total_amount').val(result.totalAmount);

    if (result.matanahFound) {
        $modal.find('#cover_surcharge').prop('disabled', true);
    }
    updatePledgePayNowButtonEnabledState($modal);

    if (payType === 'pay') {
        refreshManagerPledgeModalOpenPaymentSection($modal);
    }
    if (typeof mgrPledgeModalSyncQrPayButtonText === 'function') {
        mgrPledgeModalSyncQrPayButtonText($modal);
    }

    $modal.modal('show');

    $modal.one('shown.bs.modal', function () {
        if ($modal.find('input[name="payment_mode"]:checked').val() === 'recurring') {
            initializeRecurringTable($modal);
        }
    });
}


function initializeRecurringTable($modal) {
    const $table = $modal.find('#set_payment_table');
    const $tbody = $table.find('tbody');
    const rowCount = $tbody.find('tr').length;

    if ($table.length && rowCount > 1) {
        $tbody.sortable({
            handle: 'td:first-child',
            cursor: 'move',
            update: function () {
                $tbody.find('tr').each(function (index) {
                    $(this).find('td:first-child').text(index + 1);
                });
            }
        });
        $tbody.find('tr').hover(
            function () { $(this).addClass('sortable-hover'); },
            function () { $(this).removeClass('sortable-hover'); }
        );
        $modal.find('[data-toggle="tooltip"]').tooltip({ trigger: 'hover' });
        return;
    }

    destroyRecurringTable($modal);
}

function destroyRecurringTable($modal) {
    const $table = $modal.find('#set_payment_table');
    const $tbody = $table.find('tbody');
    if ($tbody.hasClass('ui-sortable')) {
        $tbody.sortable('destroy');
    }
    $tbody.find('tr').removeClass('sortable-hover');
}

window.runChangeAmount = runChangeAmount;
window.setPledgePaySubmitInProgress = setPledgePaySubmitInProgress;
window.isPledgePaySubmitInProgress = isPledgePaySubmitInProgress;
window.openPledgePayPage = openPledgePayPage;
window.openMembersPayOneBillPage = openMembersPayOneBillPage;
window.runSelectedMemberBills = runSelectedMemberBills
window.formatPledgeForPaymentTable = formatPledgeForPaymentTable;
window.formatPledgeDateUsDisplay = formatPledgeDateUsDisplay;
window.saveMatanahAmount = saveMatanahAmount
window.renderPledgePaymentTable = renderPledgePaymentTable
window.calculateRecurringPaymentAmount = calculateRecurringPaymentAmount;
window.setPledgeStartDateByFrequency = setPledgeStartDateByFrequency;
window.formatCurrency = formatCurrency;
window.getRecurringSchedulePledges = getRecurringSchedulePledges;
window.getRecurringBalanceDueTotal = getRecurringBalanceDueTotal;
window.getRecurringBalanceDueTotalForInstallment = getRecurringBalanceDueTotalForInstallment;
window.getRecurringEditModalPledgeAmount = getRecurringEditModalPledgeAmount;
window.syncPledgeBalanceDueDisplay = syncPledgeBalanceDueDisplay;
window.getRecurringPledgeCount = getRecurringPledgeCount;
window.getInstallmentAmount = getInstallmentAmount;
window.setPledgeTotals = setPledgeTotals;
window.validatePledgeAmountInput = validatePledgeAmountInput;
window.validateRecurringInstallmentMinimum = validateRecurringInstallmentMinimum;
window.setInstallmentAmountNote = setInstallmentAmountNote;
window.updateOngoingDurationOption = updateOngoingDurationOption;
window.updateRecurringInstallmentAmount = updateRecurringInstallmentAmount;
window.closeEditOngoingPledgeModal = closeEditOngoingPledgeModal;
window.resetPledgePaymentModalState = resetPledgePaymentModalState;
window.openPayBillModal = openPayBillModal;
window.pledgeAmountToPayRowsInvalid = pledgeAmountToPayRowsInvalid;
window.syncPledgeAmountToPayValidation = syncPledgeAmountToPayValidation;
window.shouldSkipAmountToPayRowForStatement = shouldSkipAmountToPayRowForStatement;
window.initializeRecurringTable = initializeRecurringTable
window.destroyRecurringTable = destroyRecurringTable
window.updateMultiGatewayPaymentModeWarning = updateMultiGatewayPaymentModeWarning
window.refreshManagerPledgeModalOpenPaymentSection = refreshManagerPledgeModalOpenPaymentSection

